<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row v-if="pagePrincipal" align="center" justify="center">
          <v-col cols="12" sm="12" md="9" lg="9">
            <v-card class="login" flat style="border-radius: 10px; padding: 10px;">
              <span class="login-title">
                <img :src="empresa.logoUrl" width="100%" style="max-width: 200px">
              </span>
              <v-card-actions style="padding: 0px; margin-top: 0px;">
                <v-container fluid grid-list-md style="padding: 0px">
                  <v-layout row wrap justify-center v-if="eventos.length >= 1">
                    <v-container>
                      <v-row dense>
                        <v-col cols="12" sm="12" md="4" lg="4" v-for="evento in eventos" :key="evento.id">
                          <v-card outlined>
                            <v-alert v-if="evento.exibePorcentagem" style="margin: 0px; text-align: center; border-radius: 0px" color="red" dark dense>
                              <b v-if="evento.exigePagamento">{{ (evento.quantidadeInscricoes * 100 / evento.vagas).toFixed(0) }}% VENDIDOS</b>
                              <b v-else>{{ (evento.quantidadeInscricoes * 100 / evento.vagas).toFixed(0) }}% VENDIDOS</b>
                            </v-alert>
                            <v-img class="mx-auto" height="auto" width="100%" :src="evento.urlCapa"></v-img>
                            <v-card-title class="mx-auto no-break">{{ evento.nome }}</v-card-title>
                            <v-card-text>
                              <div>
                                <v-icon>mdi-calendar</v-icon>
                                {{ formatDateHora(evento.inicio) }}
                              </div>
                              <div style="margin-top: 5px" v-if="evento.local">
                                <v-icon>mdi-map-marker</v-icon>
                                {{ evento.local }} <span v-if="evento.localizacao">(<a :href="evento.localizacao" target="_blank">Ver no mapa</a>)</span>
                              </div>
                              <div style="margin-top: 5px" v-if="evento.exigePagamento && !evento.valorPix && !evento.valorCartao">
                                <v-icon>mdi-ticket-confirmation</v-icon>
                                Setores disponíveis:
                                <ul style="margin: 0px; padding-left: 5px" v-for="valor in evento.setores" :key="valor.nome">
                                  <p :style="'margin: 0px; color: ' + valor.cor">
                                    <v-icon :color="valor.cor" size="12" style="padding-bottom: 2px">mdi-circle</v-icon>
                                    {{ valor.nome }}: R$ {{ valor.valor }}
                                  </p>
                                </ul>
                              </div>
                              <div style="margin-top: 5px" v-if="!evento.exigePagamento && !evento.valorPix && !evento.valorCartao">
                                <v-icon>mdi-ticket-confirmation</v-icon>

                                <ul style="margin: 0px" v-for="valor in evento.setores" :key="valor.nome">
                                  <li>{{ valor.nome }}: R$ {{ valor.valor }}</li>
                                </ul>
                              </div>
                              <div style="margin-top: 5px" v-if="evento.valorPix && evento.valorCartao">
                                <ul style="margin: 0px; padding-left: 5px">
                                  <p style="margin: 0px" v-if="evento.valorPix"><b>Pix:</b> R$ {{ evento.valorPix }}</p>
                                  <p style="margin: 0px" v-if="evento.valorCartao"><b>Cartão:</b> em até {{ evento.quantidadeParcelas }}x de {{ ((parseFloat(evento.valorCartao.replace(',','.')) + parseFloat(evento['acrescimoCartao' + evento.quantidadeParcelas].replace(',','.'))) / evento.quantidadeParcelas).toLocaleString("pt-BR", {style:"currency", currency:"BRL"}) }}</p>
                                </ul>
                              </div>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" :disabled="evento.quantidadeInscricoes >= evento.vagas" @click="realizarInscricaoGrupo(evento)">Inscrever agora</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-flex xs12 sm12 lg12 style="text-align: center; padding: 0px 10px 0px 10px; margin-bottom: 17px">
                      <v-card flat>
                        <img style="margin-right: 5px" src="../../assets/site-seguro-blindado.png" width="300px">
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 v-if="empresa.telefone" style="padding: 0px 10px 0px 10px">
                      <v-btn depressed block style="border-radius: 7px" large :href="'https://wa.me/55' + empresa.telefone + '?text=Olá,%20pode%20me%20ajudar%20com%20os%20eventos%20da%20empresa%20' + empresa.nome + '?'" target="_blank">
                        <v-icon left>chat</v-icon>
                        Dúvidas? Fale Conosco!
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center v-else-if="eventos.length == 0">
                    <v-flex xs12 sm12 lg12>
                      <v-alert type="info">Nenhum evento em cartaz</v-alert>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <!-- pagina pagamento -->
        <v-row v-if="pagePagamento" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12 v-if="indicacao">
                      <v-alert type="info">
                        Você está usando o link do divulgador {{ this.divulgador.nome }}
                      </v-alert>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Preencha os dados do cartão de crédito:</p>
                    </v-flex>    
                    <v-flex xs12 sm12 lg8>
                      <v-text-field light v-model="pagamento.nomeTitular" label="NOME IMPRESSO NO CARTÃO" single-line outlined color="#00695C" dense hide-details required v-validate="'required'" :error-messages="errors.collect('nomeCartao')" data-vv-name="nomeCartao"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field light v-model="pagamento.cartaoNumero" v-mask="maskCartao" label="NÚMERO DO CARTÃO" single-line outlined color="#00695C" dense hide-details required v-validate="'required'" :error-messages="errors.collect('numCartao')" data-vv-name="numCartao"></v-text-field>
                    </v-flex> 
                    <v-flex xs12 sm12 lg3>
                      <v-text-field light v-model="pagamento.cpfTitular" v-mask="'###.###.###-##'" v-validate="'required|cpf'" :error-messages="errors.collect('cpftitular')" data-vv-name="cpftitular" label="CPF DO TITULAR" single-line outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>                  
                    <v-flex xs12 sm12 lg2>
                      <v-text-field light v-mask="'###'" v-model="pagamento.cvv" label="CVV" single-line outlined color="#00695C" dense hide-details type="password" required v-validate="'required'" :error-messages="errors.collect('codCartao')" data-vv-name="codCartao"></v-text-field>
                    </v-flex> 
                    <v-flex xs12 sm12 lg2>
                      <v-select outlined dense v-model="pagamento.mesVencimento" :items="mesesVencimento" hide-details item-text="titulo" item-value="id" color="#00695C" label="MÊS VENCIMENTO" v-validate="'required'" :error-messages="errors.collect('expiraCartaoMes')" data-vv-name="expiraCartaoMes"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg2>
                      <v-select outlined dense v-model="pagamento.anoVencimento" :items="anosVencimento" hide-details item-text="titulo" item-value="id" color="#00695C" label="ANO VENCIMENTO" v-validate="'required'" :error-messages="errors.collect('expiraCartaoAno')" data-vv-name="expiraCartaoAno"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-select outlined dense v-model="pagamento.bandeira" :items="bandeiras" hide-details item-text="text" item-value="value" color="#00695C" label="BANDEIRA" v-validate="'required'" :error-messages="errors.collect('bandeira')" data-vv-name="bandeira"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-select outlined dense v-model="pagamento.valorEscolhido" :items="parcelas" hide-details color="#00695C" label="PARCELAS" v-validate="'required'" :error-messages="errors.collect('parcelas')" data-vv-name="parcelas" @input="carregaQtdParcelas"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Preencha as informações de endereço e e-mail</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field light v-mask="'#####-###'" v-model="pagamento.cep" label="CEP" single-line outlined type="tel" color="#00695C" dense hide-details required v-validate="'required'"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field light v-model="pagamento.numero" label="NÚMERO DO ENDEREÇO" single-line outlined type="tel" color="#00695C" dense hide-details required v-validate="'required'"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-text-field light v-model="pagamento.email" label="E-MAIL" single-line outlined color="#00695C" dense hide-details required v-validate="'required'"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-left>
                    <v-flex xs10 sm10 lg12 style="margin-top: 20px">
                      <h2>Detalhes da Compra:</h2>
                    </v-flex>
                    <v-flex xs10 sm10 lg12>
                      <h4 style="color: orange">
                        {{ eventoSelecionado.nome }}
                      </h4>
                    </v-flex>
                    <v-flex xs10 sm10 lg12>
                      <h2 style="color: orange" v-if="!textoParcela">
                        Total:
                        {{
                          valorTotalCompra.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}
                      </h2>
                      <h2 style="color: orange" v-else>{{ textoParcela }}</h2>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg8>
                      <v-btn dark depressed block color="#00695C" style="border-radius: 7px;" large @click="pagamentoCartao">Realizar Pagamento</v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-btn dark depressed block color="#E53935" style="border-radius: 7px;" large @click="cancelarPagamento">Cancelar</v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="text-align: center">
                      <img src="../../assets/site-seguro-blindado.png" width="100%" style="max-width: 280px">
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- pagina pagamento -->

        <!-- pagina consulta -->
        <v-row v-if="pageConsulta" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>  
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Selecione o evento que você deseja consultar:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-select outlined dense v-model="eventoId" :items="eventos" item-text="nome" item-value="id" color="#00695C"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Preencha os dados abaixo para consultar a inscrição:</p>
                    </v-flex>   
                    <v-flex xs12 sm12 lg12 style="margin: 0 auto">
                      <v-text-field light label="CPF" color="#00695C" outlined v-mask="'###.###.###-##'" dense hide-details required v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel" v-model="cpf"></v-text-field>
                    </v-flex> 
                    <!-- <v-flex xs12 sm12 lg8>
                      <v-text-field light v-model="email" label="EMAIL" outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex> -->
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg8>
                      <v-btn dark depressed block color="#00695C" style="border-radius: 7px;" large @click="consultarInscricao(cpf)">Consultar Inscrição</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- fim pagina consulta -->

        <!-- PÁGINA INSCRIÇÃO -->
        <v-row v-if="paginaInscricaoGrupo" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12 v-if="!bloqueiaVoltar">
                      <v-btn outlined @click="retornaPaginaPrincipal">
                        <v-icon left>mdi-arrow-left</v-icon>
                        Voltar
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="text-align: center" v-if="eventoSelecionado.urlMapa">
                      <!-- <h3 style="margin: 0px">Mapa do evento</h3> -->
                      <img :src="eventoSelecionado.urlMapa" alt="MapaEvento" width="100%" style="max-width: 500px; margin-top: 10px">
                    </v-flex>

                    <v-container fluid grid-list-md style="padding: 0px">
                      <v-layout row wrap justify-left style="margin-bottom: 0px">                        
                        <v-flex xs12 sm12 lg12 v-if="eventoSelecionado.tipoDocumento == 'AMBOS'">
                          <v-radio-group v-model="inscricao.tipoDocumento" row>
                            <v-radio label="CPF" value="CPF"></v-radio>
                            <v-radio label="CNPJ" value="CNPJ"></v-radio>
                          </v-radio-group>
                          <v-alert v-if="eventoSelecionado.desconto && inscricao.tipoDocumento == 'CNPJ'" dark type="success">Desconto de R$ {{ eventoSelecionado.desconto }} aplicado!</v-alert>
                        </v-flex>

                        <v-flex xs12 sm12 lg4 v-if="eventoSelecionado.tipoDocumento == 'CNPJ' || inscricao.tipoDocumento == 'CNPJ'">
                          <v-text-field label="CNPJ" v-model="inscricao.cpf" light color="#00695C" outlined v-mask="'##.###.###/####-##'" dense hide-details required type="tel" @change="verificaDocumento(inscricao.cpf, 'CNPJ')"></v-text-field>
                        </v-flex>
                        
                        <v-col xs12 sm12 lg2>
                          <v-col xs12 sm12 lg12>
                            <p style="margin-bottom: 0px;">Selecione o turno: <b style="color:#F44336">*</b></p>
                          </v-col>

                          <v-col xs12 sm12 lg10>
                            <v-select outlined dense hide-details v-model="inscricao.turno" :items="turno"></v-select>
                          </v-col>
                        </v-col>

                        <v-col xs12 sm12 lg4 v-if="inscricao.turno != ''">
                          <v-col xs12 sm12 lg4>
                            <p style="margin-bottom: 0px;">Selecione a turma: <b style="color:#F44336">*</b></p>
                          </v-col>

                          <v-col xs12 sm12 lg11>
                            <v-select outlined dense hide-details v-model="inscricao.turma" v-if="inscricao.turno == 'MANHÃ'" :items="turmasManha"></v-select>
                            <v-select outlined dense hide-details v-model="inscricao.turma" v-else :items="turmasTarde"></v-select>
                          </v-col>
                        </v-col>

                        <v-col xs12 sm12 lg4 v-if="inscricao.turma != ''">
                          <v-col xs12 sm12 lg12 style="margin-top: 32px">
                            <v-switch v-model="inscricao.integral" label="Modalidade INTEGRAL" color="primary"></v-switch>
                          </v-col>
                        </v-col>

                        <v-container>
                          <p style="margin-bottom: 0px;">Status do Aluno: <b style="color:#F44336">*</b></p>
                          <v-radio-group v-model="inscricao.statusAluno" inline>
                            <v-radio
                              label="Novato"
                              value="novato"
                            ></v-radio>
                            <v-radio
                              label="Veterano"
                              value="veterano"
                            ></v-radio>
                          </v-radio-group>
                        </v-container>

                        <v-flex xs12 sm12 lg12>
                          <p style="margin-bottom: 0px;">Dados da mãe: <b style="color:#F44336">*</b></p>
                        </v-flex>

                        <v-flex xs12 sm12 lg8 v-if="eventoSelecionado.tipoDocumento == 'CPF' || inscricao.tipoDocumento == 'CPF'">
                          <v-text-field label="NOME COMPLETO DA MÃE" v-model="inscricao.nomeMae" light outlined color="#00695C" dense hide-details required></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 lg4>
                          <v-text-field label="WHATSAPP COM DDD DA MÃE" v-model="inscricao.telefoneMae" light color="#00695C" type="tel" outlined hide-details v-mask="'(##) #####-####'" dense required></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 lg12>
                          <p style="margin-bottom: 0px;">Dados do pai: <b style="color:#F44336">*</b></p>
                        </v-flex>

                        <v-flex xs12 sm12 lg8 v-if="eventoSelecionado.tipoDocumento == 'CPF' || inscricao.tipoDocumento == 'CPF'">
                          <v-text-field label="NOME COMPLETO DO PAI" v-model="inscricao.nomePai" light outlined color="#00695C" dense hide-details required></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 lg4>
                          <v-text-field label="WHATSAPP COM DDD DO PAI" v-model="inscricao.telefonePai" light color="#00695C" type="tel" outlined hide-details v-mask="'(##) #####-####'" dense required></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 lg12>
                          <p style="margin-bottom: 0px;">Dados do responsável financeiro: <b style="color:#F44336">*</b></p>
                        </v-flex>

                        <v-flex xs12 sm12 lg8>
                          <v-text-field label="Nome do responsável financeiro" v-model="inscricao.nomeResopnsavelFinanceiro" light color="#00695C" outlined hide-details dense required></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 lg4 v-if="eventoSelecionado.tipoDocumento == 'CPF' || inscricao.tipoDocumento == 'CPF'">
                          <v-text-field label="CPF" v-model="inscricao.cpf" light color="#00695C" outlined v-mask="'###.###.###-##'" dense hide-details required :rules="[cpfRule]"></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 lg12>
                          <p style="margin-bottom: 0px;">Telefone extra de um familiar: <b style="color:#F44336">*</b></p>
                        </v-flex>

                        <v-flex xs12 sm12 lg4>
                          <v-text-field label="WHATSAPP COM DDD" v-model="inscricao.telefoneExtra" light color="#00695C" type="tel" outlined hide-details v-mask="'(##) #####-####'" dense required></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 lg8 v-if="eventoSelecionado.tipoDocumento == 'CNPJ' || inscricao.tipoDocumento == 'CNPJ'">
                          <v-text-field label="RAZÃO SOCIAL" v-model="inscricao.nome" light single-line outlined color="#00695C" dense hide-details required></v-text-field>
                        </v-flex>

                        <!-- <v-flex xs12 sm12 lg6>
                          <v-text-field label="E-MAIL" v-model="inscricao.email" light outlined color="#00695C" dense hide-details required></v-text-field>
                        </v-flex> -->
                        
                      </v-layout>
                      <br>
                      <v-divider></v-divider>
                    </v-container>


                    <v-container fluid grid-list-md v-for="index in qtdCompra" :key="index" style="padding: 0px">
                      <br>
                      <v-layout row wrap justify-left style="margin-bottom: 0px">
                        <v-flex xs12 sm12 lg12>
                          <!-- <p style="margin-bottom: 0px;" v-if="qtdCompra != 1">Dados do {{ index }}º filho:</p> -->
                          <p style="margin-bottom: 0px;">Dados do filho(a): <b style="color:#F44336">*</b></p>
                        </v-flex>

                        <v-flex xs12 sm12 lg8>
                          <v-text-field label="NOME COMPLETO" v-model="inscricao.nome" light outlined color="#00695C" dense hide-details required></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 lg4>
                          <v-text-field label="DATA NASCIMENTO" v-model="inscricao.dataNascimento" light outlined v-mask="'##/##/####'" color="#00695C" dense hide-details required></v-text-field>
                        </v-flex>

                        <!-- <v-flex xs12 sm12 lg4>
                          <v-select label="TURMA" v-model="inscricao.filho.turma" outlined dense :items="turmas" hide-details color="#00695C"></v-select>
                        </v-flex> -->

                        <v-flex xs12 sm12 lg12>
                          <p style="margin-bottom: 0px;">Preencha com o endereço de residência da criança: <b style="color:#F44336">*</b></p>
                        </v-flex>
                        <v-flex xs12 sm12 lg3>
                          <v-text-field
                            label="CEP"
                            v-model="inscricao.cep"
                            light
                            color="#00695C"
                            outlined
                            hide-details
                            v-mask="'#####-###'"
                            dense
                            required
                            @blur="retornoCEP"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 lg9>
                          <v-text-field
                            light
                            v-model="inscricao.logradouro"
                            label="RUA"
                            outlined
                            color="#00695C"
                            dense
                            hide-details
                            required
                            readonly
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 lg4>
                          <v-text-field
                            light
                            v-model="inscricao.estado"
                            label="ESTADO"
                            outlined
                            color="#00695C"
                            dense
                            hide-details
                            required
                            readonly
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 lg4>
                          <v-text-field
                            light
                            v-model="inscricao.cidade"
                            label="CIDADE"
                            outlined
                            color="#00695C"
                            dense
                            hide-details
                            required
                            readonly
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 lg4>
                          <v-text-field
                            light
                            v-model="inscricao.bairro"
                            label="BAIRRO"
                            outlined
                            color="#00695C"
                            dense
                            hide-details
                            required
                            readonly
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 lg4>
                          <v-text-field
                            light
                            v-model="inscricao.numero"
                            label="Nº"
                            outlined
                            color="#00695C"
                            dense
                            hide-details
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 lg8>
                          <v-text-field
                            light
                            v-model="inscricao.complemento"
                            label="COMPLEMENTO"
                            outlined
                            color="#00695C"
                            dense
                            hide-details
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 lg12>
                        </v-flex>

                        <v-flex xs12 sm12 lg4>
                          <v-switch v-model="inscricao.alergia" label="Sua criança é alérgica a algo?" color="primary"></v-switch>
                        </v-flex>

                        <v-flex xs12 sm12 lg8 v-show="inscricao.alergia">
                          <v-text-field label="Se sim, o que seria?" v-model="inscricao.alergiaDescricao" light single-line outlined color="#00695C" dense hide-details required></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 lg4>
                          <v-switch v-model="inscricao.neurodivergencia" label="Sua criança é neurodivergente?" color="primary"></v-switch>
                        </v-flex>

                        <v-flex xs12 sm12 lg8 v-show="inscricao.neurodivergencia">
                          <v-text-field label=" Se sim, qual seria a neurodivergência?" v-model="inscricao.neurodivergenciaDescricao" light single-line outlined color="#00695C" dense hide-details required></v-text-field>
                        </v-flex>

                        <!-- INICIO ANEXOS-->
                        <v-flex xs12 sm12 lg12>
                          <v-divider></v-divider>
                          <br>
                          <p style="margin-bottom: 0px;">Faça o envio das imagens:</p>
                          <br>
                        </v-flex>

                          <!-- FOTO CRIANCA -->
                        <v-flex xs12 sm12 lg4 style="text-align: center">
                          <v-card style="border-radius: 5px;">
                            <file-upload
                              class="btn btn-primary"
                              input-id="file1"
                              extensions="pdf,gif,jpg,jpeg,png,webp"
                              accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                              post-action="/upload/post"
                              v-model="arquivoFotoCache"
                              @input-filter="inputFilter"
                              @input-file="inputFileFoto"
                              ref="upload1"
                            >
                              <p class="form-titulo" style="font-size: 15px">FOTO 3X4 CRIANCA <b style="color:#F44336">*</b></p>
                              <v-btn v-if="arquivoFotoCache == ''" style="border-radius: 8px;" dark color="#4A148C">Selecionar arquivo</v-btn>
                              <v-btn v-if="arquivoFotoCache != ''" style="border-radius: 8px;" dark color="#4A148C">Selecionar outro arquivo</v-btn>
                              <p id="arquivoFoto" value=""></p>
                              <p v-if="arquivoFotoCache == ''">Nenhum arquivo selecionado</p>
                              <div v-else>
                                <p v-for="(file) in arquivoFotoCache" :key="file.id">{{file.name}}</p>
                              </div>
                            </file-upload>
                          </v-card>
                        </v-flex>

                          <!-- CERTIDAO NASCIMENTO -->
                        <v-flex xs12 sm12 lg4 style="text-align: center">
                          <v-card style="border-radius: 5px;">
                            <file-upload
                              class="btn btn-primary"
                              input-id="file2"
                              extensions="pdf,gif,jpg,jpeg,png,webp"
                              accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                              post-action="/upload/post"
                              v-model="arquivoCertidaoNascimentoCache"
                              @input-filter="inputFilter"
                              @input-file="inputFileCertidaoNascimento"
                              ref="upload1"
                            >
                              <p class="form-titulo" style="font-size: 15px">CERTIDÃO NASCIMENTO <b style="color:#F44336">*</b></p>
                              <v-btn v-if="arquivoCertidaoNascimentoCache == ''" style="border-radius: 8px;" dark color="#4A148C">Selecionar arquivo</v-btn>
                              <v-btn v-if="arquivoCertidaoNascimentoCache != ''" style="border-radius: 8px;" dark color="#4A148C">Selecionar outro arquivo</v-btn>
                              <p id="arquivoCertidaoNascimento" value=""></p>
                              <p v-if="arquivoCertidaoNascimentoCache == ''">Nenhum arquivo selecionado</p>
                              <div v-else>
                                <p v-for="(file) in arquivoCertidaoNascimentoCache" :key="file.id">{{file.name}}</p>
                              </div>
                            </file-upload>
                          </v-card>
                        </v-flex>
                                
                          <!-- CNH/RG PAI -->
                        <v-flex xs12 sm12 lg4 style="text-align: center">
                          <v-card style="border-radius: 5px;">
                            <file-upload
                              class="btn btn-primary"
                              input-id="file3"
                              extensions="pdf,gif,jpg,jpeg,png,webp"
                              accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                              post-action="/upload/post"
                              v-model="arquivoCnhRg1Cache"
                              @input-filter="inputFilter"
                              @input-file="inputFileCnhRgPai"
                              ref="upload1"
                            >
                              <p class="form-titulo" style="font-size: 15px">CNH/RG DO PAI <b style="color:#F44336">*</b></p>
                              <v-btn v-if="arquivoCnhRg1Cache == ''" style="border-radius: 8px;" dark color="#4A148C">Selecionar arquivo</v-btn>
                              <v-btn v-if="arquivoCnhRg1Cache != ''" style="border-radius: 8px;" dark color="#4A148C">Selecionar outro arquivo</v-btn>
                              <p id="arquivoCnhRg1" value=""></p>
                              <p v-if="arquivoCnhRg1Cache == ''">Nenhum arquivo selecionado</p>
                              <div v-else>
                                <p v-for="(file) in arquivoCnhRg1Cache" :key="file.id">{{file.name}}</p>
                              </div>
                            </file-upload>
                          </v-card>
                        </v-flex>

                          <!-- CNH/RG MAE-->
                        <v-flex xs12 sm12 lg4 style="text-align: center">
                          <v-card style="border-radius: 5px;">
                            <file-upload
                              class="btn btn-primary"
                              input-id="file4"
                              extensions="pdf,gif,jpg,jpeg,png,webp"
                              accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                              post-action="/upload/post"
                              v-model="arquivoCnhRg2Cache"
                              @input-filter="inputFilter"
                              @input-file="inputFileCnhRgMae"
                              ref="upload1"
                            >
                              <p class="form-titulo" style="font-size: 15px">CNH/RG DA MAE <b style="color:#F44336">*</b></p>
                              <v-btn v-if="arquivoCnhRg2Cache == ''" style="border-radius: 8px;" dark color="#4A148C">Selecionar arquivo</v-btn>
                              <v-btn v-if="arquivoCnhRg2Cache != ''" style="border-radius: 8px;" dark color="#4A148C">Selecionar outro arquivo</v-btn>
                              <p id="arquivoCnhRg2" value=""></p>
                              <p v-if="arquivoCnhRg2Cache == ''">Nenhum arquivo selecionado</p>
                              <div v-else>
                                <p v-for="(file) in arquivoCnhRg2Cache" :key="file.id">{{file.name}}</p>
                              </div>
                            </file-upload>
                          </v-card>
                        </v-flex>

                          <!-- CNH/RG RESPONSAVEL FINANCEIRO-->
                        <v-flex xs12 sm12 lg4 style="text-align: center">
                          <v-card style="border-radius: 5px;">
                            <file-upload
                              class="btn btn-primary"
                              input-id="file5"
                              extensions="pdf,gif,jpg,jpeg,png,webp"
                              accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                              post-action="/upload/post"
                              v-model="arquivoCnhRg3Cache"
                              @input-filter="inputFilter"
                              @input-file="inputFileCnhRgRespFinanceiro"
                              ref="upload1"
                            >
                              <p class="form-titulo" style="font-size: 15px">CNH/RG DO RESP. FINANCEIRO <b style="color:#F44336">*</b></p>
                              <v-btn v-if="arquivoCnhRg3Cache == ''" style="border-radius: 8px;" dark color="#4A148C">Selecionar arquivo</v-btn>
                              <v-btn v-if="arquivoCnhRg3Cache != ''" style="border-radius: 8px;" dark color="#4A148C">Selecionar outro arquivo</v-btn>
                              <p id="arquivoCnhRg3" value=""></p>
                              <p v-if="arquivoCnhRg3Cache == ''">Nenhum arquivo selecionado</p>
                              <div v-else>
                                <p v-for="(file) in arquivoCnhRg3Cache" :key="file.id">{{file.name}}</p>
                              </div>
                            </file-upload>
                          </v-card>
                        </v-flex>

                          <!-- CARTEIRA VACINA -->
                        <v-flex xs12 sm12 lg4 style="text-align: center">
                          <v-card style="border-radius: 5px;">
                            <file-upload
                              class="btn btn-primary"
                              input-id="file6"
                              extensions="pdf,gif,jpg,jpeg,png,webp"
                              accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                              post-action="/upload/post"
                              v-model="arquivoCadernetaVacinacaoCache"
                              @input-filter="inputFilter"
                              @input-file="inputFileCadernetaVacinacao"
                              ref="upload1"
                            >
                              <p class="form-titulo" style="font-size: 15px">CARTEIRA VACINA <b style="color:#F44336">*</b></p>
                              <v-btn v-if="arquivoCadernetaVacinacaoCache == ''" style="border-radius: 8px;" dark color="#4A148C">Selecionar arquivo</v-btn>
                              <v-btn v-if="arquivoCadernetaVacinacaoCache != ''" style="border-radius: 8px;" dark color="#4A148C">Selecionar outro arquivo</v-btn>
                              <p id="arquivoCadernetaVacinacao" value=""></p>
                              <p v-if="arquivoCadernetaVacinacaoCache == ''">Nenhum arquivo selecionado</p>
                              <div v-else>
                                <p v-for="(file) in arquivoCadernetaVacinacaoCache" :key="file.id">{{file.name}}</p>
                              </div>
                            </file-upload>
                          </v-card>
                        </v-flex>
                        

                          <!-- CARTAO SUS -->
                        <v-flex xs12 sm12 lg4 style="text-align: center">
                          <v-card style="border-radius: 5px;">
                            <file-upload
                              class="btn btn-primary"
                              input-id="file7"
                              extensions="pdf,gif,jpg,jpeg,png,webp"
                              accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                              post-action="/upload/post"
                              v-model="arquivoCartaoSusCache"
                              @input-filter="inputFilter"
                              @input-file="inputFileCartaoSus"
                              ref="upload1"
                            >
                              <p class="form-titulo" style="font-size: 15px">CARTÃO SUS <b style="color:#F44336">*</b></p>
                              <v-btn v-if="arquivoCartaoSusCache == ''" style="border-radius: 8px;" dark color="#4A148C">Selecionar arquivo</v-btn>
                              <v-btn v-if="arquivoCartaoSusCache != ''" style="border-radius: 8px;" dark color="#4A148C">Selecionar outro arquivo</v-btn>
                              <p id="arquivoCartaoSus" value=""></p>
                              <p v-if="arquivoCartaoSusCache == ''">Nenhum arquivo selecionado</p>
                              <div v-else>
                                <p v-for="(file) in arquivoCartaoSusCache" :key="file.id">{{file.name}}</p>
                              </div>
                            </file-upload>
                          </v-card>
                        </v-flex>
                        

                          <!-- COMPROVANTE RESIDENCIA -->
                        <v-flex xs12 sm12 lg4 style="text-align: center">
                          <v-card style="border-radius: 5px;">
                            <file-upload
                              class="btn btn-primary"
                              input-id="file8"
                              extensions="pdf,gif,jpg,jpeg,png,webp"
                              accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                              post-action="/upload/post"
                              v-model="arquivoComprovanteResidenciaCache"
                              @input-filter="inputFilter"
                              @input-file="inputFileComprovanteResidencia"
                              ref="upload1"
                            >
                              <p class="form-titulo" style="font-size: 15px">COMPROVANTE RESIDENCIA <b style="color:#F44336">*</b></p>
                              <v-btn v-if="arquivoComprovanteResidenciaCache == ''" style="border-radius: 8px;" dark color="#4A148C">Selecionar arquivo</v-btn>
                              <v-btn v-if="arquivoComprovanteResidenciaCache != ''" style="border-radius: 8px;" dark color="#4A148C">Selecionar outro arquivo</v-btn>
                              <p id="arquivoComprovanteResidencia" value=""></p>
                              <p v-if="arquivoComprovanteResidenciaCache == ''">Nenhum arquivo selecionado</p>
                              <div v-else>
                                <p v-for="(file) in arquivoComprovanteResidenciaCache" :key="file.id">{{file.name}}</p>
                              </div>
                            </file-upload>
                          </v-card>
                        </v-flex>
                        

                        <!-- FIM ANEXOS-->
                      </v-layout>
                    </v-container>
                    <v-flex xs12 sm12 lg12 style="margin-top: 20px">
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>                

                <v-container fluid grid-list-md v-if="eventoSelecionado.permiteSenhaExtra">
                  <v-layout row wrap justify-left style="margin-bottom: 20px">
                    <v-flex xs12 sm12 lg12>
                      <v-switch v-model="ativaComboSenhaExtra" inset label="Deseja adquirir senhas extras?"></v-switch>
                    </v-flex>

                    <v-flex xs12 sm12 lg4 v-if="ativaComboSenhaExtra">
                      <v-select label="QUANTIDADE DE SENHAS EXTRAS" hide-details v-model="inscricao.qtdSenhasExtra" outlined dense :items="numbers" color="#00695C"></v-select>
                      <p style="margin: 0px">Preço unitário da senha extra: R$ {{ eventoSelecionado.valorSenhaExtra }}</p>
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-container style="padding: 0px 12px 0px 12px">
                  <v-flex xs12 sm12 lg12>
                    <v-checkbox v-model="aceiteLgpd" style="margin-top: 10px">
                      <template v-slot:label>
                        <div>
                          Concordo com as <a target="_blank" href="https://2eea8b7d-a702-46f5-8be7-466aa412f79b.usrfiles.com/ugd/2eea8b_6acd8479401b41da80bfe3bbf2a0d37d.pdf" @click.stop>políticas de privacidade e tratamento de dados pessoais</a>
                        </div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                </v-container>
                <v-container style="padding: 0px 12px 0px 12px" v-if="eventoSelecionado.urlImgObs">
                  <v-flex xs12 sm12 lg12 style="text-align: center">
                    <img :src="eventoSelecionado.urlImgObs" width="100%" style="max-width: 300px">
                  </v-flex>
                </v-container>
                <v-container style="padding: 0px 12px 0px 12px">
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">
                    <h2>Detalhes da Compra:</h2>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 style="margin: 5px 0px 5px 0px">
                    <h3 style="color: orange">{{ eventoSelecionado.nome }}</h3>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="!eventoSelecionado.valorPix && !eventoSelecionado.valorCartao">
                    <h3 style="color: orange">
                      Total: {{ valorTotalCompra.toLocaleString("pt-BR", {style:"currency", currency:"BRL"}) }}
                    </h3>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="eventoSelecionado.valorPix && eventoSelecionado.valorCartao">
                    <h3 style="color:orange" v-if="eventoSelecionado.valorPix">
                      <p style="margin: 0px" v-if="inscricao.statusAluno == 'novato'">Pix: {{ parseFloat(this.eventoSelecionado.valorNovato.replace(',','.')).toLocaleString("pt-BR", {style:"currency", currency:"BRL"}) }}</p>
                      <p style="margin: 0px" v-if="inscricao.statusAluno == 'veterano'">Pix: {{ parseFloat(this.eventoSelecionado.valorVeterano.replace(',','.')).toLocaleString("pt-BR", {style:"currency", currency:"BRL"}) }}</p>
                      <!-- <p style="margin: 0px" v-if="eventoSelecionado.permiteSenhaExtra">Pix: {{ (parseFloat(this.eventoSelecionado.valorPix.replace(',','.')) + parseFloat((eventoSelecionado.valorSenhaExtra.replace(',','.') * inscricao.qtdSenhasExtra))).toLocaleString("pt-BR", {style:"currency", currency:"BRL"}) }}</p> -->
                    </h3>
                    <h3 style="color:orange" v-if="eventoSelecionado.valorCartao">
                      <p style="margin: 0px" v-if="inscricao.statusAluno == 'novato'">Cartão: {{ eventoSelecionado.quantidadeParcelas }}x de {{ (parseFloat(eventoSelecionado.valorNovato.replace(',','.')) + parseFloat(eventoSelecionado['acrescimoCartao' + eventoSelecionado.quantidadeParcelas].replace(',','.')) / eventoSelecionado.quantidadeParcelas).toLocaleString("pt-BR", {style:"currency", currency:"BRL"}) }}</p>
                      <p style="margin: 0px" v-if="inscricao.statusAluno == 'veterano'">Cartão: {{ eventoSelecionado.quantidadeParcelas }}x de {{ (parseFloat(eventoSelecionado.valorVeterano.replace(',','.')) + parseFloat(eventoSelecionado['acrescimoCartao' + eventoSelecionado.quantidadeParcelas].replace(',','.')) / eventoSelecionado.quantidadeParcelas).toLocaleString("pt-BR", {style:"currency", currency:"BRL"}) }}</p>
                      <!-- <p style="margin: 0px" v-if="eventoSelecionado.permiteSenhaExtra">Cartão: {{ eventoSelecionado.quantidadeParcelas }}x de {{ (((parseFloat(eventoSelecionado.valorCartao.replace(',','.')) + parseFloat(eventoSelecionado['acrescimoCartao' + eventoSelecionado.quantidadeParcelas].replace(',','.'))) + parseFloat((eventoSelecionado.valorSenhaExtra.replace(',','.') * inscricao.qtdSenhasExtra))) / 2).toLocaleString("pt-BR", {style:"currency", currency:"BRL"}) }}</p> -->
                    </h3>
                  </v-flex>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px;" large @click="prosseguirPagamento('CARTÃO')">
                        <img style="margin-right: 5px" src="../../assets/credit-card.png" width="25px">
                        Cartão
                      </v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px;" large @click="prosseguirPagamento('BOLETO')">
                        <img style="margin-right: 5px" src="../../assets/barcode.png" width="30px">
                        Boleto
                      </v-btn>
                    </v-flex> -->
                    <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px;" large @click="prosseguirPagamento('PIX')">
                        <img style="margin-right: 5px" src="../../assets/pix.png" width="20px">
                        Pix
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="text-align: center">
                      <img style="margin-right: 5px" src="../../assets/site-seguro-blindado.png" width="250px">
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- PÁGINA INSCRIÇÃO -->
        
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoAIPassIntelite.png" width="250px">
          </a>
        </div>

        <v-dialog v-model="dialogoIngressoIndividual" persistent max-width="600px">
          <v-card style="border-radius: 10px;">
            <v-card-text style="text-align: center; padding: 0 24px 0;">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">{{ inscricaoLocalizada.nome }}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#EF6C00">Guarde esse código ou print essa imagem, será necessário para a sua identificação no dia do evento juntamente com seu documento com foto.</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto">{{ inscricaoLocalizada.eventoNome }}</p>
                    <p class="texto">{{ inscricaoLocalizada.eventoLocal }} <span v-if="inscricaoLocalizada.eventoLocalizacao">(<a :href="inscricaoLocalizada.eventoLocalizacao" target="_blank">Ver no mapa</a>)</span></p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" :style="'background-color: ' + inscricaoLocalizada.corSetor + '; color: white; padding: 5px'">SETOR: {{ inscricaoLocalizada.setor }}</p>
                  </v-col>
                  <v-col cols="12" style="padding: 2px;">
                    <v-card outlined style="padding: 10px" color="white">
                      <qrcode-vue :value="inscricaoLocalizada.cod_incricao" :size="120" level="H" bg-color="white"></qrcode-vue>
                      <p style="margin: 0px; font-weight: bold">{{inscricaoLocalizada.cod_incricao}}</p>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions style="padding-bottom: 0px" v-if="inscricaoLocalizada.eventoUsaCartaoConsumo">
              <v-btn style="border-radius: 7px;" dark depressed block color="#474c56" :href="'https://aiconsumer.intelite.com.br?cod=' + inscricaoLocalizada.cod_incricao">Cartão Consumo</v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-btn style="border-radius: 7px;" dark depressed block color="#7b4f44" @click="dialogoIngressoIndividual = false">fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoListaIngresso" persistent max-width="600px" scrollable>
          <v-card>
            <v-card-title v-if="inscricao.statusAluno == 'novato'">Matrícula</v-card-title>
            <v-card-title v-else>Rematricula</v-card-title>
            <!-- <v-card-title>Inscrições</v-card-title> -->
            <v-card-text style="padding: 0px 10px 0px 10px">
              <v-container style="padding: 12px 0px 12px 0px">
                <v-row style="margin: 10px">
                  <v-col cols="12" style="padding: 0px">
                    <p style="margin: 0px; font-weight: bold" v-if="inscricao.statusAluno == 'novato'">MATRÍCULA ESPAÇO ALEGRE 2025</p>
                    <p style="margin: 0px; font-weight: bold" v-else>{{ eventoSelecionado.nome }}</p>
                    <p style="margin: 0px; font-weight: bold">
                      <v-icon>mdi-map-marker</v-icon>{{ eventoSelecionado.local }} <span v-if="eventoSelecionado.localizacao">(<a :href="eventoSelecionado.localizacao" target="_blank">Ver no mapa</a>)</span>
                    </p>
                  </v-col>
                </v-row>
                <br>
                <v-row align="center" justify="center" style="border: 1px solid #ccc; margin: 10px; text-align: center; ">
                  <v-col cols="12" lg="4" style="padding: 2px;">
                    <v-card outlined style="padding: 10px" color="white">
                      <qrcode-vue :value="inscricao.cod_incricao" :size="70" level="H" bg-color="white"></qrcode-vue>
                      <p style="margin: 0px; font-weight: bold">{{ inscricao.cod_incricao }}</p>
                    </v-card>
                  </v-col>
                  <v-col cols="12" lg="8" style="padding: 0px;">
                    <p class="texto" style="margin: 0px">{{ inscricao.nome }}</p>
                    <p class="texto" style="margin: 0px">{{ inscricao.turno }}</p>
                    <p class="texto" style="margin: 0px">{{ inscricao.turma }}</p>
                    <!-- <p class="texto" :style="'background-color: ' + inscricao.corSetor + '; color: white; padding: 3px; margin: 0px'">SETOR: {{ inscricao.setor }}</p> -->
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn style="border-radius: 7px;" dark depressed block color="#7b4f44" @click="dialogoListaIngresso = false">fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="confirmacaoBoleto" persistent max-width="600px">
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center; padding: 8px;">
              <span class="texto">{{msgResultado}}</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0;">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">{{inscricao.nome}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#FF0000">Fique atento! Após um dia útil, será enviada uma mensagem no WhatsApp do número informado com a confirmação de pagamento e o seu ingresso digital.</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto">{{cultoSelecionado}}</p>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" style="padding: 2px;">
                    <v-btn style="border-radius: 7px;" dark depressed @click="abreBoleto">Visualizar Boleto</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px;" dark depressed block color="#7b4f44" @click="closeDialog">fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="confirmacaoEmMaos" persistent max-width="600px">
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center; padding: 8px;">
              <span class="texto">{{msgResultado}}</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0;">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">{{inscricao.nome}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#FF0000">Sua inscrição foi pré-aprovada. Para confirmar, o pagamento deve ser feito em mãos.</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto">{{cultoSelecionado}}</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px;" dark depressed block color="#7b4f44" @click="closeDialog">fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCancelamento" persistent max-width="600px">
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center; padding: 8px;">
              <span class="texto">Solicitação de Cancelamento</span>
            </v-card-title>
            <v-card-text style="text-align: center;padding:0 24px 0;">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">{{inscricao.nome}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">CPF : {{inscricao.cpf}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto">{{cultoSelecionado}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="background-color: #D32F2F;color: white;">Confirme a sua solicitação de cancelamento</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px;" dark depressed block color="#00695C" @click="realizarCancelamento">confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="pagamentoPix" persistent max-width="600px">
          <v-card style="border-radius: 10px">
            <v-card-title style="justify-content: center; padding: 4px">
              <span class="texto">{{ msgResultado }}</span>
            </v-card-title>
            <v-card-title style="justify-content: center; padding: 4px">
              <span class="texto">QR Code</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 1px">
                    <v-card flat style="padding: 10px" color="white">
                      <qrcode-vue
                        v-if="empresa.gatewayPagamentoPix == 'SICOOB'"
                        :value="qrCode64"
                        :size="300"
                        level="H"
                        bg-color="white"
                      ></qrcode-vue>
                      <img
                        v-else
                        :src="qrCode64"
                        width="100%"
                        style="max-width: 300px"
                      />
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="12" md="12" style="padding: 1px">
                    <p class="texto" style="color: orange">
                      R$
                      {{
                        (
                          parseFloat(valorTotalCompra) +
                          parseFloat(valorAcrescimo.acrescimoPix)
                        )
                          .toFixed(2)
                          .replace(".", ",")
                      }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" style="padding: 1px">
                    <p class="texto" style="color: #00695c" v-if="empresa.gatewayPagamentoPix == 'TAPAGO'">
                      Nome Fantasia: INTELITE TECNOLOGIA FLAGSHIP
                    </p>
                    <p class="texto" style="color: #00695c" v-else>
                      Nome Fantasia: VA SERVICOS DE EVENTOS RECEPCOES DE FESTA E RESTAURANTES LTDA
                    </p>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" style="padding: 1px">
                    <p class="texto" style="color: #00695c">
                      Solicitação Pagador: {{ empresa.nome }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" style="padding: 1px; position: absolute; left: -99999px">
                    <v-text-field id="chavePix" v-model="chaveCopiaeCola"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" style="padding: 1px">
                    <v-btn dark depressed color="#00695C" @click="doCopy('chavePix')">Copiar Chave</v-btn>
                  </v-col>
                  <br />
                  <v-col cols="12" sm="12" md="12" style="padding: 1px; margin-top: 20px">
                    <p class="texto">
                      Faça a leitura do QR Code ou copie a chave e cole no
                      aplicativo de seu banco na função "Pix Copia e Cola".
                      Realize o pagamento e aguarde a confirmação. Pode levar
                      até 02 (dois) minutos.
                    </p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <!-- <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px;" dark depressed block color="#00695C" @click="closeDialog">Finalizar</v-btn>
            </v-card-actions> -->
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoToken" persistent max-width="400px">
          <v-card style="border-radius: 10px;">
            <v-card-text style="text-align: center; padding:0 24px 0;">
              <v-container>
                <p><b>Enviamos um token para seu WhatsApp.<br>Por favor, informe-o abaixo para ter acesso ao seu ingresso digital:</b></p>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="4" style="padding: 1px;">
                    <v-text-field light v-mask="'####'" v-model="token" label="TOKEN" type="tel" single-line outlined color="#00695C" dense hide-details required></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-container fluid grid-list-md>
                <v-spacer></v-spacer>
                <v-btn style="border-radius: 7px;" dark block depressed color="#00695C" @click="confirmaToken">Confirmar</v-btn>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ textoSnackbar }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">Fechar</v-btn>
      </template>
    </v-snackbar>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  /* import vueCard from 'vue-card-express'; */
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import CpfValidate from '../../componentes/validators/rules/cpf'
  import CnpjValidate from '../../componentes/validators/rules/cnpj'
  import QrcodeVue from 'qrcode.vue'
  import { baseApiUrl, /* modelBoleto */ } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import FileUpload from 'vue-upload-component'
  import {
    mapState
  } from 'vuex'
  import moment from 'moment'
  import axios from 'axios'
  export default {
    components: {
      Snackbar,
      QrcodeVue,
      Loading,
      FileUpload
    },
    name: 'Auth',

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,

      numbers() {
        return Array.from({ length: 50 }, (_, index) => index + 1);
      }
    }),

    data: function () {
      return {
        valorParcela: 0,
        timeout: 4000,
        snackbar: false,
        textoSnackbar: '',
        pagamentoPix: false,
        localPagamento: '',
        eventoId: '',
        cpf: '',
        email: '',
        qtdCompra: 1,
        pagePrincipal: true,
        pagePagamento: false,
        pageConsulta: false,
        PageIncricao: false,
        maskCartao: "#### #### #### ####",
        user: {},
        cultoSelecionado: null,
        arquivoFotoCache: [],
        arquivoCertidaoNascimentoCache: [],
        arquivoCnhRg1Cache: [],
        arquivoCnhRg2Cache: [],
        arquivoCnhRg3Cache: [],
        arquivoCadernetaVacinacaoCache: [],
        arquivoCartaoSusCache: [],
        arquivoComprovanteResidenciaCache: [],
        inscricao: {
          cod_incricao: '',
          nome: '',
          nomePai: '',
          nomeMae: '',
          telefonePai: '',
          telefoneMae: '',
          telefoneExtra: '',
          nomeResopnsavelFinanceiro: '',
          cpf: '',
          turno: '',
          turma: '',
          statusAluno: 'veterano',
          integral: false,
          cep: '',
          logradouro: '',
          estado: '',
          cidade: '',
          bairro: '',
          numero: '',
          complemento: '',
          alergia: false,
          alergiaDescricao: '',
          neurodivergencia: false,
          neurodivergenciaDescricao: '',
          arquivoFoto: '',
          arquivoCertidaoNascimento: '',
          arquivoCnhRg1: '',
          arquivoCnhRg2: '',
          arquivoCnhRg3: '',
          arquivoCadernetaVacinacao: '',
          arquivoCartaoSus: '',
          arquivoComprovanteResidencia: '',
          email: '',
          sexo: '',
          eventoId: '',
          lote: 0,
          tipo: "VIRTUAL",
          tipoDocumento: '',
          valorPago: '',
          qtdSenhasExtra: 0,
          filho: [],
        },
        inscricaoDefault: {
          cod_incricao: '',
          nome: '',
          nomePai: '',
          nomeMae: '',
          telefonePai: '',
          telefoneMae: '',
          telefoneExtra: '',
          nomeResopnsavelFinanceiro: '',
          cpf: '',
          turno: '',
          turma: '',
          statusAluno: 'veterano',
          integral: false,
          cep: '',
          logradouro: '',
          estado: '',
          cidade: '',
          bairro: '',
          numero: '',
          complemento: '',
          alergia: false,
          alergiaDescricao: '',
          neurodivergencia: false,
          neurodivergenciaDescricao: '',
          arquivoFoto: '',
          arquivoCertidaoNascimento: '',
          arquivoCnhRg1: '',
          arquivoCnhRg2: '',
          arquivoCnhRg3: '',
          arquivoCadernetaVacinacao: '',
          arquivoCartaoSus: '',
          arquivoComprovanteResidencia: '',
          email: '',
          sexo: '',
          eventoId: '',
          lote: 0,
          tipo: "VIRTUAL",
          tipoDocumento: '',
          valorPago: '',
          qtdSenhasExtra: 0,
          filho: [],
        },
        pagamento: {
          valor: 0,
          cartaoNumero: '',
          cvv: '',
          mesVencimento: '',
          anoVencimento: '',
          nomeTitular: '',
          cpfTitular: '',
          bandeira: '',
          cep: '',
          numero: '',
          email: ''
        },
        exibePreenchimento: false,
        exibePreenchimento2: false,
        dialogCancelamento: false,
        dialogoIngressoIndividual: false,
        confirmacaoBoleto: false,
        confirmacaoEmMaos: false,
        qtdInscritos: 0,
        capacidadeEvento: 0,
        reserva: 0,
        sexo: ['MASCULINO', 'FEMININO'],
        tipo: ['MEMBRO', 'VISITANTE'],
        tamanhos: ['PP', 'P', 'M', 'G', 'GG', 'XG'],
        mesesVencimento: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        anosVencimento: [],
        eventos: [],
        condicoes: [
          { value: true, text: 'SIM' },
          { value: false, text: 'NÃO' }
        ],
        necessidades: ['AUDITIVA', 'CADEIRANTE', 'VISUAL'],
        bandeiras: [
          {value: 'DINERS', text: "DINERS"},
          {value: 'ELO', text: "ELO"},
          {value: 'HIPERCARD', text: "HIPERCARD"},
          {value: 'MASTERCARD', text: "MASTERCARD"},
          {value: 'VISA', text: "VISA"}
        ],
        turno: ['MANHÃ','TARDE',],
        turmasManha: [
          "2° A (ENSINO INFANTIL)",
          "3° A (ENSINO INFANTIL)",
          "4° A (ENSINO INFANTIL)",
          "5° A (ENSINO INFANTIL)",
        ],
        turmasTarde: [
          "2° B (ENSINO INFANTIL)",
          "2° C (ENSINO INFANTIL)",
          "2° D (ENSINO INFANTIL)",
          '2° E (ENSINO INFANTIL)',
          "3° B (ENSINO INFANTIL)",
          "3° C (ENSINO INFANTIL)",
          "3° D (ENSINO INFANTIL)",
          "3° E (ENSINO INFANTIL)",
          "4° B (ENSINO INFANTIL)", 
          "4° C (ENSINO INFANTIL)", 
          "4° D (ENSINO INFANTIL)", 
          "4° E (ENSINO INFANTIL)", 
          "5° B (ENSINO INFANTIL)", 
          "5° C (ENSINO INFANTIL)", 
          "5° D (ENSINO INFANTIL)",
          "5° E (ENSINO INFANTIL)",
          "1° ANO A (ENSINO FUNDAMENTAL I)",
          "1° ANO B (ENSINO FUNDAMENTAL I)",
          "2° ANO (ENSINO FUNDAMENTAL I)",
          "3° ANO (ENSINO FUNDAMENTAL I)",
          "4° ANO (ENSINO FUNDAMENTAL I)",
          "5° ANO (ENSINO FUNDAMENTAL I)",
        ],
        parcelas: [],
        modelCartao: {
          id: '',
          valor: '',
          tipoTransacao: 'A_VISTA',
          quantidadeParcelas: 1,
          comprador: {
            id: '',
            documentoNumero: '',
            documentoTipo: '1',
            email: '',
            nomeCompleto: '',
            primeiroNome: '',
            ultimoNome: '',
            enderecoLogradouro: '',
            enderecoNumero: '',
            enderecoComplemento: '',
            enderecoCep: '',
            enderecoBairro: '',
            enderecoCidade: '',
            enderecoEstado: '',
          },
          cartao: {
            numero: '',
            codigoSeguranca: '',
            nome: '',
            expiracaoAno: '',
            expiracaoMes: '',
            bandeira: ''
          }
        },
        cobrancaAsaas: {
          customer: '',
          billingType: '',
          value: 0,
          dueDate: '',
          description: ''
        },
        cobrancaAsaasCartao: {
          customer: '',
          billingType: '',
          value: 0,
          dueDate: '',
          description: '',
          remoteIp: '',
          creditCard: {
            holderName: '',
            number: '',
            expiryMonth: '',
            expiryYear: '',
            ccv: ''
          },
          creditCardHolderInfo: {
            name: '',
            email: '',
            cpfCnpj: '',
            postalCode: '',
            addressNumber: '',
            phone: ''
          }
        },
        clienteAsaas: {
          name: '',
          cpfCnpj: '',
          email: '',
          mobilePhone: '',
          postalCode: '',
          addressNumber: '',
          notificationDisabled: true,
        },
        tokenAsaas: '49c4e67d3ee1f8dc149532590589285abc97c9b10a8c3759e9b6f63e383a76d3',
        qrCode64: '',
        chaveCopiaeCola: '',
        empresa: [],
        isLoading: false,
        fullPage: true,
        jaExiste: false,
        codigoExistente: '',
        msgResultado: '',
        idInscricao: [],
        codigoAcesso: '',
        informaMunicipio: true,
        idClienteAsaas: '',
        valorAcrescimo: {
          acrescimoBoleto: 0.00,
          acrescimoPix: 0.00,
        },
        qtdInscMasculinas: 0,
        qtdInscFemininas: 0,
        vagasMasculinas: 0,
        vagasFemininas: 0,
        textoParcela: '',
        paginaInscricaoGrupo: false,
        caravana: false,
        inscricaoLocalizada: {
          cod_incricao: '',
          nome: '',
          email: '',
          sexo: '',
          telefone: '',
          eventoNome: '',
          eventoLocal: '',
          eventoLocalizacao: '',
          eventoUsaCartaoConsumo: '',
          setor: '',
          corSetor: ''
        },
        linkBoleto: '',
        consultaCPF: false,
        dialogoToken: false,
        token: '',
        divulgador: [],
        indicacao: false,
        possuiCupom:false,
        cupomDesconto: '',
        cupomAplicado: false,
        loader: null,
        loadingCupom: false,
        dadosCupom: [],
        qtdParcelas: null,
        usaCupomDesconto: null,
        tipoIngresso: '',
        eventoSelecionado: [],
        usaCartaoConsumo: null,
        bloqueiaVoltar: false,
        estados: [],
        municipios: [],
        tiposDocumento: ["CPF","CNPJ"],
        valorTotalCompra: 0,
        aceiteLgpd: false,
        dialogoListaIngresso: false,
        ativaComboSenhaExtra: false,
        cpfRule: value => value && value.length === 14 || 'CPF incompleto',
        dictionary: {
          custom: {
            nomeCartao: {
              required: () => 'Informe o nome'
            },
            numCartao: {
              required: () => 'Informe o número do cartão de crédito',
            },
            cpftitular: {
              required: () => 'Informe o número do cartão de crédito',
            },
            codCartao: {
              required: () => 'Informe o código de segurança'
            },
            expiraCartaoMes: {
              required: () => 'Informe o mês de validade do cartão',
            },
            expiraCartaoAno: {
              required: () => 'Informe o ano de validade do cartão',
            },
            dateOfBirth: {
                required: () => 'Informe a Data de Nascimento' ,
                date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
            },
          }
        }
      }
    },
    
    mounted: async function () {
      await this.carregaDados()
      this.pegaParametrosUrl()
      this.$validator.localize('pt', this.dictionary)
      this.buscaUfs()
      this.buscaMunicipios()
    },

    watch: {
      dialogoIngressoIndividual(val) {
        if (val == false) {
          setTimeout(() => {
            let keys = Object.keys(this.inscricaoLocalizada)

            for (let i = 0; i < keys.length; i++) {
              this.inscricaoLocalizada[keys[i]] = ''
            }
          }, 300)
        }
      },

      dialogoListaIngresso(val) {
        if (val == false) {
          this.inscricao = Object.assign({}, this.inscricaoDefault)
          this.pagePrincipal = true
          this.paginaInscricaoGrupo = false
          this.pagePagamento = false
          this.idInscricao = []
        }
      },

      ativaComboSenhaExtra(val) {
        if (val == false) {
          this.inscricao.qtdSenhasExtra = 0
        }
      },
    },

    methods: {
      retornaMunicipios(uf) {
        return this.municipios.filter(municipios => municipios['UF-sigla'] === uf)
      },

      criarQuantidades(minimo, maximo) {
        this.quantidade = []
        
        for (let i = 0; i < 51; i++) {
          if (i >= minimo && i <= maximo) {
            this.quantidade.push(i)
          }
        }
      },

      criarAnosVencimento() {
        this.anosVencimento = []
        let anoAtual = new Date().toISOString().substring(0, 4)
        let anoFinal = parseInt(new Date().toISOString().substring(0, 4)) + 14

        while ( anoAtual <= anoFinal ) {
          this.anosVencimento.push((anoAtual++).toString());
        }
      },

      doCopy(id) {
        try {
          let copyText = document.getElementById(id);
          copyText.select();
          copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
          document.execCommand("copy");
          this.snackbar = true
          this.textoSnackbar = 'Chave copiada para a área de transferência!'
        } catch (error) {
          this.snackbar = true
          this.textoSnackbar = 'Problema ao copiar chave para a área de transferência'
        }
      },

      reloadPage() {
        window.location.reload()
      },

      async carregaDados() {
        this.eventos = []
        this.isLoading = true

        await axios.post(baseApiUrl + 'eventos/eventosFuturos', {"empresaId":"6602f657e8c46733a5e18786"})
        .then(async response => {
          this.eventos = response.data.eventos
          this.empresa = response.data.empresa
          this.isLoading = false
        })
      },

      calculaParcelas(evento, qtdCompra) {
        let valorTotal;

        if (qtdCompra) {
          valorTotal =
            parseFloat(evento.valorCartao.replace(",", ".")) +
            parseFloat(
              evento["acrescimoCartao" + evento.quantidadeParcelas].replace(
                ",",
                "."
              )
            );
          valorTotal = valorTotal * qtdCompra;
          valorTotal = parseFloat(
            valorTotal / evento.quantidadeParcelas
          ).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
        } else {
          valorTotal =
            parseFloat(evento.valorCartao.replace(",", ".")) +
            parseFloat(
              evento["acrescimoCartao" + evento.quantidadeParcelas].replace(
                ",",
                "."
              )
            );
          valorTotal = parseFloat(
            valorTotal / evento.quantidadeParcelas
          ).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
        }
        return valorTotal;
      },

      criarParcelas(valor, qtdCompra) {
        this.parcelas = [];

        for (let i = 0; i < this.qtdParcelas; i++) {
          // incrementa o índice do for para usar como número da parcela
          let numeroParcela = i + 1;

          // faz a soma do valor unitário com o referido acréscimo
          let valorIndividualComAcrescimo =
            parseFloat(valor) +
            parseFloat(
              this.valorAcrescimo["acrescimoCartao" + numeroParcela].replace(
                ",",
                "."
              ) * qtdCompra
            );

          // multiplica o valor individual com acréscimo com a quantidade a ser adquirida
          // let valorTotal = (valorIndividualComAcrescimo * qtdCompra)
          let valorTotal = valorIndividualComAcrescimo;

          // divide o valor total pelo número da parcela
          let valorParcela = valorTotal / numeroParcela;

          // cria a string contendo todas as informações necessárias
          let textoParcela =
            numeroParcela +
            "X de R$ " +
            valorParcela.toFixed(2).replace(".", ",") +
            " (Total R$ " +
            valorTotal.toFixed(2).replace(".", ",") +
            ")";

          this.parcelas.push(textoParcela);
        }
      },

      cancelarPagamento () {
        
        //this.removeCupom()
        this.pagePagamento = false
        if (this.caravana) {
          this.paginaInscricaoGrupo = true
        } else {
          this.PageIncricao = true
        }
      },

      /* formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      }, */

      formatDatePadrao(date) {
        if (!date) return null

        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatDateBrz(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      async acessaConsulta() {
        this.pagePrincipal = false
        this.pageConsulta = true
      },

      async solicitaCancelamento() {
        this.pagePrincipal = false
        this.pageConsulta = true
        if (this.inscricao.nome == '' || this.eventoId == '' || this.inscricao.cpf == '') {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha os campos: Evento, Nome e CPF para solicitar o cancelamento!", "ATENÇÃO")
        } else {
          this.isLoading = false
          this.dialogCancelamento = true
        }
      },

      async realizarCancelamento() {
        this.idInscricao = ''
        this.isLoading = true
        try {
          let res = await axios.get(`${baseApiUrl}Inscricoes?filter={"where":{"and":[{"eventoId":"${this.eventoId}"},{"cpf":"${this.inscricao.cpf}"}]}}`)
          if (res.data[0].id) {
            this.idInscricao = res.data[0].id
          } else {
            this.isLoading = false
            this.dialogCancelamento = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível localizar a inscrição, verifique os dados e tente novamente!", "ATENÇÃO")
          }
        } catch (error) {
          this.isLoading = false
          this.dialogCancelamento = false
          vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível localizar a inscrição, verifique os dados e tente novamente!", "ATENÇÃO")
        }
        if (this.idInscricao != '') {
          try {
            let res = await axios.delete(`${baseApiUrl}Inscricoes/${this.idInscricao}`)
            if (res.data != '') {
              this.isLoading = false
              this.inscricao = Object.assign({}, this.inscricaoDefault)
              this.dialogCancelamento = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#0288D1", "Cancelamento realizado com sucesso!", "INFORMAÇÃO")
            } else {
              this.isLoading = false
              this.dialogCancelamento = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!", "ATENÇÃO")
            }
          } catch (error) {
            this.isLoading = false
            this.dialogCancelamento = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!", "ATENÇÃO")
          }
        }
      },

      async aplicaCupom() {
        var vm = this;

        if (this.cupomDesconto) {
          await axios.get(baseApiUrl + 'Cupons?filter={"where":{"nome":"' + this.cupomDesconto.toUpperCase().trim() + '"}}')
          .then(response => {
            if (response.data) {
              if (response.data[0].nome.toUpperCase() == this.cupomDesconto.toUpperCase().trim() && response.data[0].quantidade > response.data[0].utilizados) {
                this.dadosCupom = response.data[0]
                this.cupomAplicado = true                
                this.valorTotalCompra = (parseFloat(parseFloat(this.valorTotalCompra) - parseFloat(this.dadosCupom.valor)).toFixed(2)).replace('.',',')
              }
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#F9A825", "Cupom inválido ou esgotado!", "ATENÇÃO")
          })
        }
      },

      removeCupom() {
        this.valorTotalCompra = (parseFloat(parseFloat(this.valorTotalCompra) + parseFloat(this.dadosCupom.valor)).toFixed(2)).replace('.',',')
        this.cupomAplicado = false
        this.dadosCupom = []
        this.possuiCupom = false
        this.cupomDesconto = ''
      },

      async atualizaCupomsUtilizados() {
        await axios.patch(baseApiUrl + 'Cupons/' + this.dadosCupom.id, {"utilizados": this.dadosCupom.utilizados + 1} )
      },

      carregaQtdParcelas() {
      for (let i = 0; i < this.parcelas.length; i++) {
        if (this.pagamento.valorEscolhido == this.parcelas[i]) {
          this.cobrancaAsaasCartao.installmentCount = parseInt(
            this.parcelas[i].split("X")[0]
          );
          this.textoParcela = this.parcelas[i];

          const parcela = this.parcelas[i];
          const match = parcela.match(/\(Total R\$\s*([\d,]+)\)/);

          if (match && match[1]) {
            this.pagamento.valor = match[1].replace(",", ".");
          }
        }
      }
    },

      async prosseguirPagamento(formaPagamento) {
        let vm = this
        this.isLoading = true
        let inscricoesValidas = []
        await this.pegaVagasDisponiveis()

        //Verifica CPF
        if (!CpfValidate(this.inscricao.cpf)) {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#F9A825", 'CPF inválido! Preencha com um CPF válido!', "ATENÇÃO")
          return
        }

        //Verifica campos
        if (!this.validarCamposInscricaoCPF(this.inscricao)) {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#F9A825", 'Preencha todos os campos corretamente para confirmar a inscrição!', "ATENÇÃO")
          return
        }

        //Caso tenha novos arquivos, adicione ao array abaixo
        const fields = [
          'arquivoFoto',
          'arquivoCertidaoNascimento',
          'arquivoCnhRg1',
          'arquivoCnhRg2',
          'arquivoCnhRg3',
          'arquivoCadernetaVacinacao',
          'arquivoCartaoSus',
          'arquivoComprovanteResidencia'
        ];

        //Verifica se todos os arquivos foram enviados e preenche os campos
        fields.forEach(field => {
          const value = document.getElementById(field).value;
          if (value) {
            this.inscricao[field] = value;
          }
        });

        //Verifica se todos os arquivos foram enviados
        if (!this.inscricao.arquivoFoto || !this.inscricao.arquivoCertidaoNascimento  || !this.inscricao.arquivoCadernetaVacinacao || !this.inscricao.arquivoCartaoSus || !this.inscricao.arquivoComprovanteResidencia || !this.inscricao.arquivoCnhRg1 || !this.inscricao.arquivoCnhRg2 || !this.inscricao.arquivoCnhRg3) {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#F9A825", "Para continuar é necessário enviar todos os arquivos!", "ATENÇÃO")
          return
        }

        //Verifica termos e condicoes
        if (!this.aceiteLgpd) {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#F9A825", "Para continuar, concorde com as políticas de privacidade e tratamento de dados pessoais", "ATENÇÃO")
          return
        }

        this.inscricao.setor = this.eventoSelecionado.setores[0].nome
        this.inscricao.corSetor = this.eventoSelecionado.setores[0].cor        

        if (this.inscricao.qtdSenhasExtra) {
          if (formaPagamento == 'CARTÃO') {
            this.inscricao.valorPago = parseFloat(this.eventoSelecionado.valorCartao.replace(',','.')) + parseFloat((this.eventoSelecionado.valorSenhaExtra.replace(',','.') * this.inscricao.qtdSenhasExtra))
          } else {
            this.inscricao.valorPago = parseFloat(this.eventoSelecionado.valorPix.replace(',','.')) + parseFloat((this.eventoSelecionado.valorSenhaExtra.replace(',','.') * this.inscricao.qtdSenhasExtra))
          }
        } else {
          if (formaPagamento == 'CARTÃO') {
            if (this.inscricao.statusAluno == 'novato') {
              this.inscricao.valorPago = this.eventoSelecionado.valorNovato
            } else {
              this.inscricao.valorPago = this.eventoSelecionado.valorVeterano
            }
          } else {
            if (this.inscricao.statusAluno == 'novato') {
              this.inscricao.valorPago = this.eventoSelecionado.valorNovato
            } else {
              this.inscricao.valorPago = this.eventoSelecionado.valorVeterano
            }
          }
        }

        // verifica tipoDocumento da inscrição e se todas as informações estão preenchidas
        if (this.inscricao.tipoDocumento == 'CPF' && !this.validarCamposInscricaoCPF(this.inscricao)) {
          vm.$refs.chamaSnackbar.snack("#F9A825", 'Preencha todos os campos corretamente para confirmar a inscrição!', "ATENÇÃO")
          return
        }
        else if (this.inscricao.tipoDocumento == 'CNPJ' && !this.validarCamposInscricaoCNPJ(this.inscricao)) {
          vm.$refs.chamaSnackbar.snack("#F9A825", 'Preencha todos os campos corretamente para confirmar a inscrição!', "ATENÇÃO")
          return
        }
        else {
          for (let i = 0; i < this.inscricao.filho.length; i++) {
            if (!this.inscricao.filho[i].nome || !this.inscricao.filho[i].turma) {
              vm.$refs.chamaSnackbar.snack("#F9A825", 'Preencha todas as informações corretamente do ' + (i + 1) + 'º filho!', "ATENÇÃO")
              i = this.inscricao.filho.length
              return
            }
          }
        }

        if (this.ativaComboSenhaExtra && !this.inscricao.qtdSenhasExtra) {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Para continuar, informe a quantidade de senhas extras", "ATENÇÃO")
          return
        }

        if (this.vagasDisponiveis[this.inscricao.setor] > 0) {
          inscricoesValidas.push(this.inscricao)
        } else {
          vm.$refs.chamaSnackbar.snack("#F9A825", 'Quantidade máxima do setor selecionado para a inscrição foi atingida. Selecione outro setor.', "ATENÇÃO")
          return
        }

        if (inscricoesValidas.length == 1) {
          if (formaPagamento == 'CARTÃO') {
            if (this.inscricao.statusAluno == 'novato') {
              this.valorTotalCompra = this.eventoSelecionado.valorNovato
            } else {
              this.valorTotalCompra = this.eventoSelecionado.valorVeterano
            }
            // if (this.eventoSelecionado.valorCartao) {
            //   if (this.ativaComboSenhaExtra) {
            //     this.valorTotalCompra = parseFloat(this.eventoSelecionado.valorCartao.replace(',','.')) + (parseFloat(this.eventoSelecionado.valorSenhaExtra.replace(',','.') * this.inscricao.qtdSenhasExtra))
            //   } else {
            //     this.valorTotalCompra = this.eventoSelecionado.valorCartao
            //   }
            // }
            this.criarAnosVencimento()
            this.criarParcelas(this.valorTotalCompra, 1)
            this.pagamento.email = this.inscricao.email
            this.paginaInscricaoGrupo = false
            this.pagePagamento = true;
            this.isLoading = false
          } else if (formaPagamento == 'PIX') {
            if (this.eventoSelecionado.valorPix) {
              if (this.inscricao.statusAluno == 'novato') {
                this.valorTotalCompra = this.eventoSelecionado.valorNovato
              } else {
                this.valorTotalCompra = this.eventoSelecionado.valorVeterano
              }
              // if (this.ativaComboSenhaExtra) {
              //   this.valorTotalCompra = parseFloat(this.eventoSelecionado.valorPix.replace(',','.')) + (parseFloat(this.eventoSelecionado.valorSenhaExtra.replace(',','.') * this.inscricao.qtdSenhasExtra))
              // } else {
              //   this.valorTotalCompra = this.eventoSelecionado.valorPix
              // }
            }
            this.callFunctionPixPayment()
          } else if (formaPagamento == 'BOLETO') {
            if (this.eventoSelecionado.valorPix) {
              if (this.ativaComboSenhaExtra) {
                this.valorTotalCompra = parseFloat(this.eventoSelecionado.valorPix.replace(',','.')) + (parseFloat(this.eventoSelecionado.valorSenhaExtra.replace(',','.') * this.inscricao.qtdSenhasExtra))
              } else {
                this.valorTotalCompra = this.eventoSelecionado.valorPix
              }
            }
            this.pagamentoBoleto()
          }
        }        
      },

      callFunctionPixPayment() {
        if (this.empresa.gatewayPagamentoPix == "TAPAGO") {
          this.pagarPixTaPago()
        }
        else if (this.empresa.gatewayPagamentoPix == "ASAAS") {
          this.pagarPixAsaas()
        }
        else if (this.empresa.gatewayPagamentoPix == "SICOOB") {
          this.pagarPixSicoob()
        }
      },

      async pagarPixSicoob() {
      this.isLoading = true;

      await this.realizarInscricao(null, "PIX", "A VISTA");
        if (this.idInscricao.length > 0) {
          let codInscricaoGeral = this.inscricao[0].cod_incricao

          // for (let i = 0; i < this.inscricao.length; i++) {
          //   if (i == 0) {
          //     codInscricaoGeral = this.inscricao[i].cod_incricao;
          //   } else {
          //     codInscricaoGeral += ", " + this.inscricao[i].cod_incricao;
          //   }
          // }

          let dadosCobranca = {
            empresaId: this.empresa.id,
            inscricaoId: this.idInscricao,
            calendario: {
              expiracao: 3600
            },
            devedor: {
              cpf: this.inscricao[0].cpf,
              nome: this.inscricao[0].nome,
            },
            valor: {
              original: ""
            },
            chave: "",
            solicitacaoPagador: "Ref. ao evento " + this.eventoSelecionado.nome + " para a insc. de nº " + codInscricaoGeral + ", qtd insc. " + this.inscricao.length
          };

          dadosCobranca.valor.original = (parseFloat(this.valorTotalCompra) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(",", "."))).toFixed(2);

          await axios.post(baseApiUrl + "Pagamentos/sicoobCobranca", dadosCobranca)
          .then((response) => {
            if (response.data) {
              this.qrCode64 = response.data.brcode
              this.chaveCopiaeCola = response.data.brcode
              this.msgResultado = "Pré-inscrição realizada com sucesso";
              this.pagamentoPix = true;
              this.isLoading = false;
              this.consultaPagamentoPixSicoob();
              if (this.cupomAplicado) this.atualizaCupomsUtilizados();
            }
          })
          .catch(() => {
            this.isLoading = false;
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao gerar pagamento. Tente novamente mais tarde.", "DESCULPE");
          });
        } else {
          this.isLoading = false;
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao realizar inscrição, tente novamente!", "DESCULPE"
          );
        }
      },

      async consultaPagamentoPixSicoob() {
        try {
          this.verificaPagamento = setInterval(
            async function () {
              await axios.post(baseApiUrl + "Pagamentos/sicoobCobrancaConsulta", {"inscricaoId": this.idInscricao[0]})
              .then((res3) => {
                if (res3.data.status == "APPROVED") {
                  this.isLoading = true;
                  this.finalizaInscricao('PIX');
                  clearInterval(this.verificaPagamento);
                }
              });
            }.bind(this), 5000);
        } catch (error) {
          clearInterval(this.verificaPagamento);
          this.isLoading = false;
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Não foi possível verificar o pagamento, tente novamente!", "DESCULPE");
        }
      },

      validarCamposInscricaoCPF(inscricao) {
        if (
          inscricao.nome.trim() === '' ||
          inscricao.nomeMae.trim() === '' ||
          inscricao.nomePai.trim() === '' ||
          inscricao.telefoneMae.trim() === '' ||
          inscricao.telefonePai.trim() === '' ||
          inscricao.telefoneExtra.trim() === '' ||
          inscricao.turno.trim() === '' ||
          inscricao.turma.trim() === '' ||
          inscricao.cep.trim() === '' ||
          inscricao.cpf.trim() === '' ||
          !CpfValidate(inscricao.cpf)
        ) {
          return false
        } else {
          return true
        }
      },

      validarCamposInscricaoCNPJ(inscricao) {
        if (
          inscricao.nome.trim() === '' ||
          inscricao.cpf.trim() === '' ||
          !CnpjValidate(inscricao.cpf) ||
          inscricao.telefone.trim() === '' ||
          inscricao.email === ''
        ) {
          return false
        } else {
          return true
        }
      },

      calculaValorInscricoes(chave) {
        let valor

        if (this.eventoSelecionado[chave]) {
          valor = parseFloat(this.eventoSelecionado[chave].replace(',','.')) * this.inscricao.length
        }
        
        for (let i = 0; i < this.inscricao.length; i++) {
          if (this.inscricao[i].tipoDocumento == 'CNPJ' && this.eventoSelecionado.desconto) {
            valor -= parseFloat(this.eventoSelecionado.desconto.replace(',','.'))
          }
        }

        return valor
      },

      async realizarInscricaoPagamento() {
        this.isLoading = true
        this.jaExiste = false
        var camposBranco = false
        this.inscricao.eventoId = this.eventoId
        var vm = this;
        if (await this.validaVagas()) {
          if (this.caravana) {
            if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.participantes == '' || this.inscricao.dataNascimento == '' || !this.inscricao.aceiteLgpd) {
              camposBranco = true
              this.isLoading = false
            }
            if (camposBranco) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
            } else {
              this.criarAnosVencimento()
              this.criarParcelas()
              this.isLoading = false
              this.pagePrincipal = false;
              this.paginaInscricaoGrupo = false
              this.pagePagamento = true;
            }
            if (this.inscricao.length == 0)
              this.isLoading = false
          } else {
            if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.dataNascimento == '') {
              camposBranco = true
              this.isLoading = false
            }
            if (camposBranco) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
            } else {
              this.criarAnosVencimento()
              this.criarParcelas()
              this.isLoading = false
              this.pagePrincipal = false;
              this.PageIncricao = false
              this.pagePagamento = true;
            }
            if (this.inscricao.length == 0)
              this.isLoading = false
          }
        }
      },

      async realizarInscricaoPagamentoBoleto() {
        this.isLoading = true
        this.jaExiste = false
        var camposBranco = false
        this.inscricao.eventoId = this.eventoId
        var vm = this;
        if (await this.validaVagas()) {
          if (this.caravana) {
            if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.participantes == '' || this.inscricao.dataNascimento == '' || !this.inscricao.aceiteLgpd) {
              camposBranco = true
              this.isLoading = false
            }
            if (camposBranco) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
            } else {
              this.pagamentoBoleto()
            }
            if (this.inscricao.length == 0)
              this.isLoading = false
          } else {
            if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.dataNascimento == '') {
              camposBranco = true
              this.isLoading = false
            }
            if (camposBranco) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
            } else {
              this.pagamentoBoleto()
            }
            if (this.inscricao.length == 0)
              this.isLoading = false
          }
        }
      },

      async realizarInscricaoPagamentoEmMaos() {
        this.isLoading = true
        this.jaExiste = false
        var camposBranco = false
        this.inscricao.eventoId = this.eventoId
        if(await this.validaVagas()){
        if(this.inscricao.dataNascimento != '' && this.calculateAge(this.formatDate(this.inscricao.dataNascimento)) < 16) 
          {
            this.isLoading = false
            var vm2 = this;
            vm2.$refs.chamaSnackbar.snack("#F9A825","Só é permitido a inscrição de maiores de 16 anos!","ATENÇÃO")
          }
        else
        {
          if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf)) {
            camposBranco = true
            this.isLoading = false
          }
          if (camposBranco) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
          } else {
            this.inscricao.statusPagamento = 'PENDENTE'
            this.inscricao.formOfPayment = 'EM MAOS'
            this.inscricao.valorPago = '330,00'
            this.realizarInscricao(this.finalizaInscricao)
          }
          if(this.inscricao.length == 0)
            this.isLoading = false
        }
        }
      },
      

      async realizarInscricaoPagamentoPix() {
        this.isLoading = true
        this.jaExiste = false
        var camposBranco = false
        this.inscricao.eventoId = this.eventoId
        var vm = this;
        if (await this.validaVagas()) {
          if (this.caravana) {
            if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.participantes == '' || this.inscricao.dataNascimento == '' || !this.inscricao.aceiteLgpd) {
              camposBranco = true
              this.isLoading = false
            }
            if (camposBranco) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
            } else {
              this.empresa.gatewayPagamentoPix == 'TAPAGO' ? this.pagarPixTaPago() : this.pagarPixAsaas()
            }
            if (this.inscricao.length == 0)
              this.isLoading = false
          } else {
            if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.dataNascimento == '') {
              camposBranco = true
              this.isLoading = false
            }
            if (camposBranco) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
            } else {
              this.empresa.gatewayPagamentoPix == 'TAPAGO' ? this.pagarPixTaPago() : this.pagarPixAsaas()
            }
            if (this.inscricao.length == 0)
              this.isLoading = false
          }
        }
      },

      realizarInscricaoAgora () {
        this.pagePrincipal = false;
        this.PageIncricao = true
        this.validaVagas()
        this.verificaCapacidade()
      },

      async realizarInscricaoGrupo (evento) {
        this.tipoIngresso = evento.nome
        this.caravana = true
        this.pagePrincipal = false;
        this.paginaInscricaoGrupo = true

        // for (let i = 0; i < evento.vendaMinima; i++) {

        //   this.inscricao.filho.push({
        //     nome: '',
        //     turma: '',
        //   })
        // }

        this.eventoSelecionado = evento
        this.eventoId = evento.id
        this.valorAcrescimo.acrescimoBoleto = evento.acrescimoBoleto  
        this.valorAcrescimo.acrescimoPix = evento.acrescimoPix

        let keys = Object.keys(evento)
        keys = keys.filter(k => k.includes('acrescimoCartao'))

        for (let i = 0; i < evento.quantidadeParcelas; i++) {
          if (keys[i]) {
            this.valorAcrescimo[keys[i]] = evento[keys[i]]
          }
          else {
            this.valorAcrescimo['acrescimoCartao' + (i + 1)] = "0,00"
          }
        }

        this.qtdParcelas = evento.quantidadeParcelas
        this.usaCupomDesconto = evento.usaCupomDesconto
        this.criarQuantidades(evento.vendaMinima, evento.vendaMaxima)
        this.qtdCompra = evento.vendaMinima
        // await this.verificaCapacidade()
        
        for (let i = 0; i < this.inscricao.length; i++) {
          if (evento.tipoDocumento == 'AMBOS') {
            this.inscricao[i].tipoDocumento = evento.documentoPadrao
          } else {
            this.inscricao[i].tipoDocumento = evento.tipoDocumento
          }
        }

        this.valorTotalCompra = 0

        if (this.empresa.limiteInscricao == 'SETOR') {
          this.pegaVagasDisponiveis()
        }
      },

      async verificaDocumento(cpf, tipo) {
        // let vm = this
        let jaExiste = false

        if ((tipo == 'CNPJ' && !CnpjValidate(cpf) || (tipo == 'CPF' && !CpfValidate(cpf)))) {
          return
        }

        /* if (this.verificaCpfInformado(cpf, index)) {
          jaExiste = true
          this.inscricao[index].cpf = ''
          vm.$refs.chamaSnackbar.snack("#F9A825", "CPF não pode ser o mesmo de um já informado!", "ATENÇÃO")
        } */

        if (!jaExiste) {
          await axios.post(baseApiUrl + 'inscricoes/consultarInscricaoCPF', { "cpf": cpf, "eventoId": this.eventoSelecionado.id })
          .then(response => {
            if (response.data.length > 0) {
              if (Object.keys(response.data[0]).includes('statusPagamento')) {
                if (response.data[0].statusPagamento == 'PAGO') {
                  // exibir diálogo com QR Code do ingresso
                  this.inscricao.cpf = ''
                  this.inscricaoLocalizada = Object.assign({}, response.data[0])
                  this.dialogoIngressoIndividual = true
                } else if (response.data[0].statusPagamento == 'PENDENTE') {
                  // this.inscricao.cod_incricao = response.data[0].cod_incricao
                  this.inscricao.cpf = response.data[0].cpf
                  this.inscricao.nome = response.data[0].nome
                  this.inscricao.telefone = response.data[0].telefone
                  this.inscricao.email = response.data[0].email
                  this.inscricao.dataNascimento = response.data[0].dataNascimento
                  this.inscricao.estado = response.data[0].estado
                  this.inscricao.cidade = response.data[0].cidade
                  this.inscricao.valorPago = response.data[0].valorPago
                  this.inscricao.tipoDocumento = response.data[0].tipoDocumento
                  // this.inscricao.id = response.data[0].id
                }
              } else {
                this.inscricao.nome = response.data[0].nome ? response.data[0].nome : ''
                this.inscricao.cpf = response.data[0].cpf ? response.data[0].cpf : ''
                this.inscricao.dataNascimento = response.data[0].dataNascimento ? response.data[0].dataNascimento : ''
                this.inscricao.telefone = response.data[0].telefone ? response.data[0].telefone : ''
                this.inscricao.email = response.data[0].email ? response.data[0].email : ''
              }
            }
          })
        }
      },

      verificaCpfInformado(cpf, indice) {
        let cpfLocalizado = false

        for (let i = 0; i < this.inscricao.length; i++) {
          if (i != indice) {
            if (this.inscricao[i].cpf == cpf) {
              cpfLocalizado = true
              break
            }
          }
        }

        return cpfLocalizado
      },

      async validaVagas() {
        var vm = this;

        try {
          await axios.get(baseApiUrl + 'inscricoes/count?where={"and":[{"eventoId":"'+this.eventoId+'"},{"sexo":"MASCULINO"}]}').then(response => {
            if (response.data) {
              this.qtdInscMasculinas = response.data.count
            }
          })
          await axios.get(baseApiUrl + 'inscricoes/count?where={"and":[{"eventoId":"'+this.eventoId+'"},{"sexo":"FEMININO"}]}').then(response => {
            if (response.data) {
              this.qtdInscFemininas = response.data.count
            }
          })
          /* let res = await axios.get(`${baseApiUrl}Inscricoes?filter[where][eventoId]=${this.eventoId}`)
          if (res.data.length > 0)
            res.data.forEach(insc => {
              if (insc.sexo == 'MASCULINO')
                this.qtdInscMasculinas = this.qtdInscMasculinas + 1
              else if (insc.sexo == 'FEMININO')
                this.qtdInscFemininas = this.qtdInscFemininas + 1
            }); */
          
          if (this.inscricao.sexo == 'MASCULINO') {
            //this.qtdInscMasculinas = this.vagasMasculinas
            if (this.qtdInscMasculinas == this.vagasMasculinas) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, todas as vagas para homens foram esgotadas!", "INFORMAÇÃO")
              return false
            } else {
              this.isLoading = false
              return true
            }
          } else if (this.inscricao.sexo == 'FEMININO') {
            if (this.qtdInscFemininas == this.vagasFemininas) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, todas as vagas para mulheres foram esgotadas!", "INFORMAÇÃO")
              return false
            } else {
              this.isLoading = false
              return true
            }
          } else {
            this.isLoading = false
            return true
          }
        } catch (error) {
          //
        }
      },

      async realizarInscricao(callback = null, formaPagamento, textoParcela) {
        this.isLoading = true
        let vm = this

        // só preenche com cod_incricao quando for nova inscrição
        if (!this.inscricao.cod_incricao) {
          this.inscricao.cod_incricao = await this.verificaCodInscricao()
        }

        this.inscricao.eventoId = this.eventoSelecionado.id
        this.inscricao.statusPagamento = "PENDENTE"
        this.inscricao.empresaId = this.empresa.id
        this.inscricao.email = this.inscricao.email.toLowerCase().trim()
        this.inscricao.formOfPayment = formaPagamento
        this.inscricao.parcelas = textoParcela
        this.inscricao.divulgadorId = this.indicacao ? this.divulgador.id : undefined
        this.inscricao.lote = this.eventoSelecionado.lote

        if (!this.inscricao.valorPago) {
          if (formaPagamento == 'CARTAO') {
            if (this.inscricao.tipoDocumento == 'CNPJ' && this.eventoSelecionado.desconto) {
              this.inscricao.valorPago = (parseFloat(this.eventoSelecionado.valorCartao.replace(',','.')) - parseFloat(this.eventoSelecionado.desconto.replace(',','.'))).toFixed(2).replace('.',',')
            } else {
              this.inscricao.valorPago = this.eventoSelecionado.valorCartao
            }
          } else if (formaPagamento == 'PIX') {
            if (this.inscricao.tipoDocumento == 'CNPJ' && this.eventoSelecionado.desconto) {
              this.inscricao.valorPago = (parseFloat(this.eventoSelecionado.valorPix.replace(',','.')) - parseFloat(this.eventoSelecionado.desconto.replace(',','.'))).toFixed(2).replace('.',',')
            } else {
              this.inscricao.valorPago = this.eventoSelecionado.valorPix
            }
          }
        }

        await axios.post(baseApiUrl + 'inscricoes/criarInscricoes', [this.inscricao])
        .then(response => {
          this.idInscricao.push(response.data[0].id)
          this.inscricao.id = response.data[0].id

          if (callback) {
            callback()
          }
        })
        .catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar cadastro, tente novamente", "ERRO")
        })
      },

      async verificaCodInscricao() {
        let codInscricao = new Date().getTime().toString()
        let codigoRetornado

        await axios.post(baseApiUrl + 'inscricoes/consultarInscricaoCodigo', {"cod_incricao": codInscricao})
        .then(async response => {
          if (response.data) {
            await this.verificaCodInscricao()
          }
        })
        .catch(error => {
          if (error.response.data.error.message.includes('não localizada')) {
            codigoRetornado = codInscricao
          }
        })

        return codigoRetornado
      },

      async atualizaInscricao(callback = null) {
        this.inscricao.id = this.idInscricao
        try {
          await axios.patch(`${baseApiUrl}Inscricoes`, this.inscricao )
          if (callback) {
            callback()
          }
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao atualizar cadastro, tente novamente", "DESCULPE")
        }
      },

      async enviaEmail () {
        try {
          await axios.post(`${baseApiUrl}Inscricoes/EnviaEmailInscrito`, {"inscricaoId": this.idInscricao} ).then(res => {
            if (res.data) {
              this.codigoAcesso = res.data.codigoAcesso
            }
          })
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao enviar e-mail, tente novamente", "DESCULPE")
        }
      },

      async realizarConsulta() {
        if(this.cpf == '') {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para realizar a consulta!", "ATENÇÃO")
        } else {
          this.isLoading = true  
          var cpfSemMascara = this.cpf.replaceAll('.', '').replaceAll('-', '')                            
          await axios.get(`${baseApiUrl}Inscricoes?filter={"where":{"and":[{"eventoId":"${this.eventoId}"},{"or":[{"cpf":"${this.cpf}"}, {"cpf":"${cpfSemMascara}"}]}]}}`).then(res => {
            if (res.data != '') {
              if (res.data[0].statusPagamento == "PENDENTE") {
                this.msgResultado = 'Inscrição localizada'
                this.cultoSelecionado = this.eventos[0].nome
                this.isLoading = false
                this.inscricao.nome = res.data[0].nome
                this.inscricao.cpf = res.data[0].cpf
                this.inscricao.email = res.data[0].email
                this.inscricao.ddd = res.data[0].ddd
                this.inscricao.telefone = res.data[0].telefone
                this.inscricao.sexo = res.data[0].sexo
                this.inscricao.participantes = res.data[0].participantes
                var vm2 = this;
                vm2.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Volte para a tela inicial e clique em 'Faça sua inscrição agora'.", "ATENÇÃO")
              } else {
                if (res.data[0].statusPagamento == "PAGO") {
                  this.cultoSelecionado = this.eventos[0].nome
                  this.inscricao.nome = res.data[0].nome
                  this.inscricao.cod_incricao = res.data[0].cod_incricao
                  this.inscricao.email = res.data[0].email
                  this.inscricao.participantes = res.data[0].participantes
                  this.dialogoIngressoIndividual = true
                  this.isLoading = false
                }
              }
            } else {
              this.isLoading = false
              vm2 = this;
              vm2.$refs.chamaSnackbar.snack("#F9A825", "Não foi localizada inscrição para os dados informados!", "ATENÇÃO")
            }
          })       
        }
      },

      async consultaInscricaoPendente(cpf, indice) {
        this.isLoading = true

        await axios.get(baseApiUrl + 'inscricoes?filter={"where":{"and":[{"eventoId":"' + this.eventoId + '"},{"cpf":"' + cpf + '"}]},"include":"evento"}')
        .then(response => {
          if (response.data) {
            if (response.data[0].statusPagamento == "PENDENTE") {
              this.inscricaoLocalizada = true
              this.msgResultado = 'Inscrição localizada'
              this.cultoSelecionado = this.eventos[0].nome
              this.isLoading = false
              this.inscricao[indice].cod_incricao = response.data[0].cod_incricao
              this.inscricao[indice].nome = response.data[0].nome
              this.inscricao[indice].cpf = response.data[0].cpf
              this.inscricao[indice].email = response.data[0].email
              this.inscricao[indice].sexo = response.data[0].sexo
              this.inscricao[indice].telefone = response.data[0].telefone
              this.inscricao[indice].eventoId = response.data[0].eventoId
              this.inscricao[indice].codigoTransacao = response.data[0].codigoTransacao
              this.inscricao[indice].estado = response.data[0].estado
              this.inscricao[indice].cidade = response.data[0].cidade
              this.inscricao[indice].id = response.data[0].id
              var vm2 = this;
              vm2.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Para prosseguir, escolha uma forma de pagamento no final do formulário.", "ATENÇÃO")
            } else if (response.data[0].statusPagamento == "PAGO") {
              this.inscricao.cod_incricao = response.data[0].cod_incricao
              this.cultoSelecionado = response.data[0].evento.nome
              this.inscricao.participantes = response.data[0].participantes
              this.inscricao.nome = response.data[0].nome
              this.codigoAcesso = response.data[0].codigoAcesso
              this.inscricao.email = response.data[0].email
              this.dialogoIngressoIndividual = true
              this.isLoading = false
            }
          } else {
            this.isLoading = false
            this.consultaDadosCpf(cpf)
          }
        })
      },

      async consultaDadosCpf(cpf) {
        await axios.get(baseApiUrl + 'inscricoes?filter={"where":{"cpf":"'+cpf+'"}}')
        .then(response => {
          if (response.data) {
            this.inscricao.nome = response.data[0].nome.trim()
            this.inscricao.dataNascimento = response.data[0].dataNascimento
            this.inscricao.telefone = response.data[0].telefone
          }
        })
      },

      async verificaCapacidade() {
        this.isLoading = true
        let vm = this
        
        this.capacidadeEvento = this.eventoSelecionado.vagas
        this.qtdInscritos = this.eventoSelecionado.quantidadeInscricoes + this.eventoSelecionado.reserva
        
        if (this.qtdInscritos + this.qtdCompra > this.capacidadeEvento && this.capacidadeEvento - this.qtdInscritos > 0) {
          this.isLoading = false
          this.qtdCompra = 1
          vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, restam apenas " + (this.capacidadeEvento - this.qtdInscritos) + " vaga(s) disponível!", "INFORMAÇÃO")
          this.verificaCapacidade()
        }
        else if (this.qtdInscritos + this.qtdCompra > this.capacidadeEvento && this.capacidadeEvento - this.qtdInscritos == 0) {
          this.isLoading = false
          this.qtdCompra = 0
          vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, todas as vagas foram esgotadas!", "INFORMAÇÃO")
          this.verificaCapacidade()
        }
        else {
          this.isLoading = false
          if (this.qtdCompra > this.inscricao.filho.length) {
            let novasInscricoes = []

            for (let i = 0; i < (this.qtdCompra - this.inscricao.filho.length); i++) {
              novasInscricoes.push({
                nome: '',
                turma: '',
              })
            }

            let novaLista = [...this.inscricao.filho, ...novasInscricoes]
            this.inscricao.filho = novaLista
          }
          else {
            this.inscricao.filho = this.removerElementos(this.inscricao.filho, (this.inscricao.filho.length - this.qtdCompra))
          }
        }
      },

      removerElementos(lista, quantidade) {
        if (lista.length >= quantidade) {
          lista.splice(-quantidade, quantidade);

          return lista
        }
      },

      async verificaVagas() {
        var vm = this;
        await axios.post(`${baseApiUrl}eventos/vagas`, {"eventoId": this.eventoId}).then(response => {
          if (response.data) {
            if (this.caravana) {
              if (response.data.vagasRestantes < 2) {
                vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, todas as vagas foram esgotadas!", "INFORMAÇÃO")
                return false
              } else if (response.data.vagasRestantes < this.inscricao.participantes) {
                vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, restam apenas " + (response.data.vagasRestantes) + " vaga(s) disponível(is)!", "INFORMAÇÃO")
                return false
              }
            } else {
              if (response.data.vagasRestantes == 0) {
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, todas as vagas foram esgotadas!", "INFORMAÇÃO")
                return false
              }
            }
            return true
          }
        })
      },

      // método de pagamento
      /* async pagarCartao() {
        if ((this.pagamento.nomeTitular != '') && (this.pagamento.cartaoNumero != '') && (this.pagamento.cpfTitular != '') && (this.pagamento.cvv != '') && (this.pagamento.mesVencimento != '') && (this.pagamento.anoVencimento != '') && (this.pagamento.bandeira != '')) {
          await this.realizarInscricao()
          if (this.idInscricao) {
            this.isLoading = true
            var primeiroUltimoNome = this.inscricao.nome.trim().split(" ")
            this.modelCartao.id = this.encrypt(this.inscricao.cod_incricao.toString())
            this.modelCartao.tipoTransacao = 'A_VISTA'
            this.inscricao.valorPago = this.valorEvento
            this.modelCartao.valor = parseFloat(this.valorEvento.replace(',','.'))
            //dados do comprador
            this.modelCartao.comprador.id = this.encrypt(this.inscricao.cod_incricao.toString())
            this.modelCartao.comprador.documentoNumero = this.inscricao.cpf.replace(/[^\d]+/g,'')
            this.modelCartao.comprador.documentoTipo = '1'
            this.modelCartao.comprador.email = this.inscricao.email
            this.modelCartao.comprador.nomeCompleto = this.inscricao.nome
            this.modelCartao.comprador.primeiroNome = primeiroUltimoNome[0]
            this.modelCartao.comprador.ultimoNome = primeiroUltimoNome[primeiroUltimoNome.length - 1]
            this.modelCartao.comprador.enderecoLogradouro = "Rua Professor Joaquim Francisco Veloso Galvao"
            this.modelCartao.comprador.enderecoNumero = "1734"
            this.modelCartao.comprador.enderecoComplemento = "Igreja da Liberdade"
            this.modelCartao.comprador.enderecoCep = "58031130"
            this.modelCartao.comprador.enderecoBairro = "EXPEDICIONARIOS"
            this.modelCartao.comprador.enderecoCidade = "JOAO PESSOA"
            this.modelCartao.comprador.enderecoEstado = "PARAIBA"
            // this.modelCartao.comprador.telefone = this.financialManagers.cellPhone
            this.modelCartao.cartao.nome = this.pagamento.nomeTitular
            // this.modelCartao.cartao.numero = this.pagamento.cartaoNumero.replace(/[^\d]+/g,'')
            this.modelCartao.cartao.codigoSeguranca = this.pagamento.cvv
            this.modelCartao.cartao.expiracaoMes = this.pagamento.mesVencimento
            this.modelCartao.cartao.expiracaoAno = this.pagamento.anoVencimento
            this.modelCartao.cartao.bandeira = this.pagamento.bandeira

            // dados para a inscrição
            this.inscricao.cardCvv = this.encrypt(this.pagamento.cvv.toString())
            this.inscricao.cardNumber = this.pagamento.cartaoNumero.replace(/[^\d]+/g,'')
            this.inscricao.cardValidity = this.pagamento.mesVencimento + this.pagamento.anoVencimento
            this.inscricao.cardHolderName = this.pagamento.nomeTitular
            this.inscricao.cardFlag = this.pagamento.bandeira
            this.atualizaInscricao()
            try {
              let res = await axios.post(`${baseApiUrl}Pagamentos/cartaocredito`, this.modelCartao) 
              if (res.data) {
                this.inscricao.codigoTransacao = res.data.transacao.autorizacaoCodigo
                this.inscricao.nsu = res.data.transacao.nsu
                this.inscricao.paymentId = res.data.pagamentoId
                this.inscricao.formOfPayment = 'CARTAO'
                this.inscricao.statusPagamento = "PAGO"
                await this.atualizaInscricao()
                this.finalizaInscricao()
              }
            } catch (error) {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao efetuar pagamento, " + error.response.data.error.mensagem,"DESCULPE!")
            }
          } else {
            this.isLoading = false
            var vm4 = this;
            vm4.$refs.chamaSnackbar.snack("#EF5350", "Falha ao realizar inscrição, tente novamente!", "DESCULPE")
          }
        } else {
          this.$validator.validateAll()
        }
      }, */

      /* async pagarBoleto() {
        await this.realizarInscricao()
        if (this.idInscricao) {
          this.isLoading = true
          // criando data de vencimeto do boleto
          var datapagvenc = new Date();
          datapagvenc.setDate(new Date().getDate())
          // criando nosso número
          var nossoNum = this.inscricao.cod_incricao.toString() + Math.floor(10 + Math.random() * 99999)
          // preencher o campos do modelBoleto
          modelBoleto.pagadorDocumentoNumero = this.inscricao.cpf.replace(/[^\d]+/g,'')
          modelBoleto.pagadorNome = this.inscricao.nome.substr(0, 39)
          modelBoleto.pagadorEndereco = "Prof Joaquim Francisco V. Galvao, 1734"
          modelBoleto.pagadorBairro = "EXPEDICIONARIOS"
          modelBoleto.pagadorCidade = "JOAO PESSOA"
          modelBoleto.pagadorUf = "PB"
          modelBoleto.pagadorCep = "58031130";
          modelBoleto.dataVencimento = datapagvenc.toISOString().substr(0, 10)
          modelBoleto.descontoDataLimite = datapagvenc.toISOString().substr(0, 10)
          // salvando o responsibility e o valor do boleto caso seja anual
          modelBoleto.valorNominal = parseFloat(this.valorEvento.replace(',','.'))
          modelBoleto.mensagem = 'Ref. ao evento ' + this.cultoSelecionado + " para a insc. de nº " + this.inscricao.cod_incricao
          modelBoleto.nsu = this.inscricao.cod_incricao
          modelBoleto.nossoNumero = nossoNum.substr(0,12)
          modelBoleto.seuNumero = nossoNum.substr(0,12)
          // gerando o Boleto e pegando o ID
          try {
            let res = await axios.post(`${baseApiUrl}Pagamentos/boletosPost`,modelBoleto)
            if (res.data != '') {
              this.inscricao.boletoId = res.data.id
              this.inscricao.formOfPayment = 'BOLETO'
              this.inscricao.situacaoBoleto = 'GERADO'
              this.inscricao.nsu = modelBoleto.nsu
              this.inscricao.nossoNumero = modelBoleto.nossoNumero
              this.inscricao.vencimentoBoleto = modelBoleto.dataVencimento
              this.inscricao.statusPagamento = 'PENDENTE'
              await this.atualizaInscricao()
              await this.imprimirBoleto()
              await this.finalizaInscricao()
            }
          } catch (error) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar boleto. Tente novamente!","DESCULPE");
            this.close()                 
          }                
        } else {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
        }
      }, */

      async pagamentoCartao() {
        let vm = this

        if ((this.pagamento.nomeTitular != '') && (this.pagamento.cartaoNumero != '') && (this.pagamento.cpfTitular != '') && (this.pagamento.cvv != '') && (this.pagamento.mesVencimento != '') && (this.pagamento.anoVencimento != '') && (this.pagamento.bandeira != '') && (this.pagamento.cep != '') && (this.pagamento.numero != '') && (this.pagamento.email != '') && (this.pagamento.valor != 0)) {
          this.isLoading = true
          
          await this.realizarInscricao(null, 'CARTAO', this.textoParcela)
          await this.criarClienteAsaas()
          if (this.idInscricao.length > 0) {
            try {
              this.cobrancaAsaasCartao.customer = this.idClienteAsaas
              this.cobrancaAsaasCartao.billingType = 'CREDIT_CARD'
              this.cobrancaAsaasCartao.value = parseFloat(this.pagamento.valor)
              this.cobrancaAsaasCartao.installmentValue = parseFloat(parseFloat(this.pagamento.valor) / this.cobrancaAsaasCartao.installmentCount)
              this.cobrancaAsaasCartao.dueDate = moment().format('YYYY-MM-DD')
              this.cobrancaAsaasCartao.description = 'Ref. ao evento ' + this.eventoSelecionado.nome + " para as insc. de nº " + this.inscricao.cod_incricao
              this.cobrancaAsaasCartao.inscricaoId = this.idInscricao
              this.cobrancaAsaasCartao.empresaId = this.empresa.id
              axios.get('https://api.ipify.org/?format=json')
              .then(res => {
                if (res.data) {
                  try {
                    this.cobrancaAsaasCartao.remoteIp = res.data.ip
                  } catch (error) {
                    this.cobrancaAsaasCartao.remoteIp = '127.0.0.1'
                  }
                } else {
                  this.cobrancaAsaasCartao.remoteIp = '127.0.0.1'
                }
              })
              // inserindo dados do cartão de crédito no objeto de pagamento
              this.cobrancaAsaasCartao.creditCard.holderName = this.pagamento.nomeTitular
              this.cobrancaAsaasCartao.creditCard.number = this.pagamento.cartaoNumero
              this.cobrancaAsaasCartao.creditCard.expiryMonth = this.pagamento.mesVencimento
              this.cobrancaAsaasCartao.creditCard.expiryYear = this.pagamento.anoVencimento
              this.cobrancaAsaasCartao.creditCard.ccv = this.pagamento.cvv
              // inserindo dados do responśavel do cartão de crédito no objeto de pagamento
              this.cobrancaAsaasCartao.creditCardHolderInfo.name = this.pagamento.nomeTitular
              this.cobrancaAsaasCartao.creditCardHolderInfo.email = this.pagamento.email.trim().toLowerCase()
              this.cobrancaAsaasCartao.creditCardHolderInfo.cpfCnpj = this.pagamento.cpfTitular
              this.cobrancaAsaasCartao.creditCardHolderInfo.postalCode = this.pagamento.cep
              this.cobrancaAsaasCartao.creditCardHolderInfo.addressNumber = this.pagamento.numero
              this.cobrancaAsaasCartao.creditCardHolderInfo.phone = this.inscricao.telefone.replace(/[^\d]+/g,'')
              await axios.post(baseApiUrl + 'Pagamentos/AsaasCobranca', this.cobrancaAsaasCartao)
              .then(response => {
                if (response.data.cobranca.status == 'CONFIRMED') {
                  this.finalizaInscricao('CARTÃO')
                  if (this.cupomAplicado)
                    this.atualizaCupomsUtilizados()
                }
              })
            } catch (error) {
              this.idInscricao = []
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#EF5350","Transação não autorizada. Verifique os dados informados e tente novamente ou utilize um outro cartão.","DESCULPE");
            }
          } else {
            this.idInscricao = []
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
          }
        } else {
          this.$validator.validateAll()
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para continuar!", "ATENÇÃO")
        }
      },

      async criarClienteAsaas() {
        this.clienteAsaas.name = this.pagePagamento ? this.pagamento.nomeTitular : this.inscricao.nome
        this.clienteAsaas.cpfCnpj = this.pagePagamento ? this.pagamento.cpfTitular : this.inscricao.cpf
        this.clienteAsaas.email = this.pagamento.email
        this.clienteAsaas.mobilePhone = this.inscricao.telefone.replace(/[^\d]+/g,'')
        this.clienteAsaas.postalCode = this.pagamento.cep
        this.clienteAsaas.addressNumber = this.pagamento.numero
        this.clienteAsaas.empresaId = this.empresa.id

        try {
          await axios.post(baseApiUrl + 'Pagamentos/criarCliente', this.clienteAsaas)
          .then(response => {
            if (response.data) {
              this.idClienteAsaas = response.data.id
            }
          })
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
        }
      },

      async pagamentoBoleto() {
        this.isLoading = true
        
        await this.realizarInscricao(null, 'BOLETO', 'A VISTA')
        await this.criarClienteAsaas()
        if (this.idInscricao.length > 0) {
          try {
            this.cobrancaAsaas.customer = this.idClienteAsaas
            this.cobrancaAsaas.value = (parseFloat(this.valorTotalCompra) + parseFloat(this.valorAcrescimo.acrescimoBoleto.replace(',','.'))).toFixed(2)
            this.cobrancaAsaas.dueDate = moment().format('YYYY-MM-DD')
            this.cobrancaAsaas.billingType = 'BOLETO'
            this.cobrancaAsaas.description = 'Ref. ao evento ' + this.cultoSelecionado + " para as insc. de nº " + this.inscricao.cod_incricao
            this.cobrancaAsaas.inscricaoId = this.idInscricao
            this.cobrancaAsaas.empresaId = this.empresa.id
            await axios.post(`${baseApiUrl}Pagamentos/AsaasCobranca`, this.cobrancaAsaas).then(res => {
              if (res.data) {
                this.linkBoleto = res.data.cobranca.bankSlipUrl
                this.finalizaInscricao('BOLETO')
                if(this.cupomAplicado)
                    this.atualizaCupomsUtilizados()
              }
            })
          } catch (error) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Problema encontrado ao gerar o boleto. Tente novamente mais tarde.","DESCULPE");
          }
        } else {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
        }
      },

      abreBoleto() {
        window.open(this.linkBoleto)
      },

      async pagarPixAsaas() {
        this.isLoading = true
        
        await this.realizarInscricao(null, 'PIX', 'A VISTA')
        await this.criarClienteAsaas()
        if (this.idInscricao.length > 0) {
          try {
            let codInscricaoGeral

            for (let i = 0; i < this.inscricao.length; i++) {
              if (i == 0) {
                codInscricaoGeral = this.inscricao[i].cod_incricao
              } else {
                codInscricaoGeral += ', ' + this.inscricao[i].cod_incricao
              }
            }

            this.cobrancaAsaas.customer = this.idClienteAsaas
            this.cobrancaAsaas.value = (parseFloat(this.valorTotalCompra) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',','.'))).toFixed(2)
            this.cobrancaAsaas.dueDate = moment().format('YYYY-MM-DD')
            this.cobrancaAsaas.billingType = 'PIX'
            this.cobrancaAsaas.description = 'Ref. ao evento ' + this.eventoSelecionado.nome + " para as insc. de nº " + codInscricaoGeral
            this.cobrancaAsaas.inscricaoId = this.idInscricao
            this.cobrancaAsaas.empresaId = this.empresa.id
            await axios.post(baseApiUrl + 'Pagamentos/AsaasCobranca', this.cobrancaAsaas)
            .then(response => {
              if (response.data) {
                this.inscricao.codigoTransacao = response.data.cobranca.invoiceUrl
                this.qrCode64 = "data:image/jpeg;base64," + response.data.qrCode.encodedImage
                this.chaveCopiaeCola = response.data.qrCode.payload
                this.msgResultado = 'Pré-inscrição realizada com sucesso'
                this.pagamentoPix = true
                this.isLoading = false
                this.inscricao.id = this.idInscricao
                this.consultaPagamentoPix(response.data.id)
                if (this.cupomAplicado)
                  this.atualizaCupomsUtilizados()
              }
            })
          } catch (error) {
            this.idInscricao = []
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao gerar pagamento. Tente novamente mais tarde.","DESCULPE");
          }
        } else {
          this.idInscricao = []
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
        }
      },

      consultaPagamentoPix() {
        try {
          this.verificaPagamento = setInterval(function() {
            axios.post(baseApiUrl + 'Pagamentos/AsaasCobrancaConsulta', {"inscricaoId": this.idInscricao[0], "empresaId": this.empresa.id})
            .then(res3 => {
              if (res3.data.status == 'RECEIVED') {
                this.finalizaInscricao('PIX')
                clearInterval(this.verificaPagamento)
              }
            })
          }.bind(this), 5000)
        } catch (error) {
          clearInterval(this.verificaPagamento)
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Não foi possível verificar o pagamento, tente novamente!","DESCULPE");
        }
      },

      async pagarPixTaPago() {
        this.isLoading = true

        await this.realizarInscricao(null, 'PIX', 'A VISTA')
        if (this.idInscricao.length > 0) {
          let dadosCobranca = {
            "empresaId": this.empresa.id,
            "inscricaoId": this.idInscricao,
            "valor": "",
            "descricao": 'Ref. ao evento ' + this.eventoSelecionado.nome + " para a insc. de nº " + this.inscricao.cod_incricao
          }

          dadosCobranca.valor = (parseFloat(this.valorTotalCompra) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',','.'))).toFixed(2)

          await axios.post(baseApiUrl + 'Pagamentos/taPagoCobranca', dadosCobranca)
          .then(response => {
            if (response.data) {
              this.qrCode64 = "data:" + response.data.instantPayment.generateImage.mimeType + ";base64," + response.data.instantPayment.generateImage.imageContent
              this.chaveCopiaeCola = response.data.instantPayment.textContent
              this.msgResultado = 'Pré-inscrição realizada com sucesso'
              this.pagamentoPix = true
              this.isLoading = false
              this.consultaPagamentoPixTaPago()
              if (this.cupomAplicado)
                this.atualizaCupomsUtilizados()
            }
          })
          .catch(() => {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao gerar pagamento. Tente novamente mais tarde.","DESCULPE");
          })
        } else {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
        }
      },

      async consultaPagamentoPixTaPago() {
        try {
          this.verificaPagamento = setInterval(async function() {
            await axios.post(baseApiUrl + 'Pagamentos/taPagoCobrancaConsulta', {"inscricaoId": this.idInscricao[0], "empresaId": this.empresa.id}).then(res3 => {
              if (res3.data.status == 'APPROVED') {
                this.isLoading = true
                this.finalizaInscricao('PIX')
                clearInterval(this.verificaPagamento)
              }
            })
          }.bind(this), 5000)
        } catch (error) {
          clearInterval(this.verificaPagamento)
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Não foi possível verificar o pagamento, tente novamente!","DESCULPE");
        }
      },

      async imprimirBoleto() {
        //Baixando Boleto PDF
        try {
          let res = await axios.get(`https://p4x.srv.br/api/v1.0/boletos/${this.inscricao.boletoId}/imprimir`, { responseType: 'arraybuffer', headers: {
            Authorization: 'Bearer ' + this.token, //the token is a variable which holds the token
            'Content-type': 'application/pdf'
          }
          })
          if  (res.data) {
            //Create a Blob from the PDF Stream
            const file = new Blob(
              [res.data],
              {type: 'application/pdf'}
            );
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileURL;
            link.setAttribute('download', 'boleto.pdf'); //or any other extension
            document.body.appendChild(link);
            link.click();
            //Open the URL on new Window
            window.open(fileURL);
            //exibe mensagem de conclusao
            this.isLoading = false
            this.dialogLoading = true
          }
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao imprimir boleto. Tente novamente ou entre em contato com a Intelite Tecnologia!","ERRO");
        }
      },

      finalizaInscricao(formaPagamento) {
        this.isLoading = false
        if (formaPagamento == 'CARTÃO') {
          this.msgResultado = 'Compra realizada com sucesso!'
          this.dialogoListaIngresso = true
        }
        else if (formaPagamento == 'BOLETO') {
          this.msgResultado = 'Pré inscrição realizada com sucesso!'
          this.confirmacaoBoleto = true
        }
        else if (formaPagamento == 'EM MAOS') {
          this.msgResultado = 'Pré inscrição realizada com sucesso!'
          this.confirmacaoEmMaos = true
        }
        else if (formaPagamento == 'PIX') {
          this.pagamentoPix = false
          this.msgResultado = 'Compra realizada com sucesso!'
          this.dialogoListaIngresso = true
        }
      },

      //Função para criptografia
      encrypt(text) {
        let crypto = require('crypto');
        let password = 'pxuelh2so839ljis';
        let iv = 'pxuelh2so839ljis';
        let cipher = crypto.createCipheriv('aes-128-cbc', password, iv);
        let encryptedData = cipher.update(text, 'utf8', 'Base64') + cipher.final('Base64');
        return encryptedData;
      },

      closeDialog() {
        this.pagamentoPix = false
        if (!this.consultaCPF) {
          this.reloadPage()
        }
        this.$validator.reset()
        if (this.consultaCPF) {
          this.consultaCPF = false
          this.inscricao = Object.assign({}, this.inscricaoDefault)
        }
      },

      compare(a, b) {
        // Use toUpperCase() to ignore character casing
        const dataA = a.nome;
        const dataB = b.nome;

        let comparison = 0;
        if (dataA > dataB) {
          comparison = 1;
        } else if (dataA < dataB) {
          comparison = -1;
        }
        return comparison;
      },

      calculateAge(dobString) {
        var dob = new Date(dobString);
        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        var birthdayThisYear = new Date(currentYear, dob.getMonth(), dob.getDate());
        var age = currentYear - dob.getFullYear();
        if (birthdayThisYear > currentDate) {
          age--;
        }
        return age;
      },

      formatDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
      },

      async pegaParametrosUrl() {
        var params = window.location.search.substring(1).split('&');
        if (params[0] != '') {
          this.isLoading = true
          let paramArray = {};                        // Criar objeto que vai conter os parametros

          for (var i = 0; i < params.length; i++) {   // Passar por todos os parametros
            var param = params[i].split('=');         // Dividir os parametros chave e valor
            paramArray[param[0]] = param[1];          // Adicionar ao objeto criado antes
          }

          if (paramArray['cod']) {
            await axios.post(baseApiUrl + 'inscricoes/consultarInscricaoCodigo', {"cod_incricao": paramArray['cod']})
            .then(async response => {
              if (response.data) {
                if (response.data.statusPagamento == 'PAGO') {
                  this.inscricaoLocalizada = Object.assign({}, response.data)
                  this.dialogoIngressoIndividual = true
                } else {
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#F9A825","Pagamento da inscrição não foi efetuado.","ATENÇÃO");
                }
              }
            })
          }
          if (paramArray['d']) {
            this.consultaDivulgador(paramArray['d'])
          }
          if (paramArray['e']) {
            await axios.post(baseApiUrl + 'eventos/porId', {"eventoId": paramArray['e']})
            .then(response => {
              if (response.data) {
                if (moment(this.formatDateHora(response.data.fim), 'DD/MM/YYYY HH:mm:ss', true).format() >= moment().format()) {
                  this.bloqueiaVoltar = true
                  this.realizarInscricaoGrupo(response.data)
                }
              }
            })
          }
        }
        this.isLoading = false
      },

      async salvaHoraVisualizacao(id) {
        await axios.patch(baseApiUrl + 'inscricoes/' + id, { "visualizado": true, "ultimaVisualizacao": moment().toISOString() })
      },

      async consultarInscricao(cpf, cod) {
        var vm = this;
        if (cpf) {
          this.isLoading = true
          let envio = {
            "eventoId": this.eventoId,
            "cpf": cpf,
            "enviaToken": true,
            "canalNotificacao": "ZAP",
            "cod_incricao": cod
          }
          try {
            await axios.post(`${baseApiUrl}inscricoes/consultarInscricao`, envio).then(response => {
              if (response.data.length > 0) {
                this.idInscricao = response.data
                this.dialogoToken = true
                this.consultaCPF = true
                this.isLoading = false
              }
            })
          } catch (error) {
            vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao consultar inscrição, tente novamente!","DESCULPE");
          }
        } else {
          vm.$refs.chamaSnackbar.snack("#F9A825","Informe o CPF para consultar","ATENÇÃO");
        }
      },

      async confirmaToken() {
        var vm = this;
        if (this.token) {
          this.isLoading = true
          let confirmacao = {
            "token": this.token,
            "inscricaoId": this.idInscricao
          }
          await axios.post(`${baseApiUrl}inscricoes/confirmToken`, confirmacao)
          .then(response => {
            if (response.data) {
              if (response.data.statusPagamento == 'PAGO') {
                this.consultaCPF = true
                this.cultoSelecionado = this.eventos[0].nome
                this.inscricao.nome = response.data.nome
                this.inscricao.cod_incricao = response.data.cod_incricao
                this.inscricao.email = response.data.email
                this.inscricao.participantes = response.data.participantes
                this.dialogoToken = false
                this.token = ''
                this.dialogoIngressoIndividual = true
                this.isLoading = false
                this.idInscricao = ''
              } else if (response.data.statusPagamento == 'PENDENTE') {
                this.inscricaoLocalizada = true
                this.consultaInscricao(this.idInscricao)
                if (response.data.participantes > 1) {
                  this.dialogoToken = false
                  this.isLoading = false
                  this.pageConsulta = false
                  this.realizarInscricaoGrupo()
                  vm.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Confirme as informações e, em seguida, escolha uma forma de pagamento desejada.", "ATENÇÃO")
                } else {
                  this.dialogoToken = false
                  this.isLoading = false
                  this.pageConsulta = false
                  this.realizarInscricaoAgora()
                  vm.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Confirme as informações e, em seguida, escolha uma forma de pagamento desejada.", "ATENÇÃO")
                }
                this.token = ''
                this.idInscricao = ''
                this.inscricao = Object.assign({}, this.inscricaoDefault)
              } else if (response.data.statusPagamento == 'CANCELADO') {
                this.dialogoToken = false
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação cancelada.", "ATENÇÃO")
                this.token = ''
                this.idInscricao = ''
                this.inscricao = Object.assign({}, this.inscricaoDefault)
              } else if (response.data.statusPagamento == 'ESTORNADO') {
                this.dialogoToken = false
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação estornada.", "ATENÇÃO")
                this.token = ''
                this.idInscricao = ''
                this.inscricao = Object.assign({}, this.inscricaoDefault)
              }
            } else {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825", "Token inválido, tente novamente", "ATENÇÃO")
            }
          }).catch(() => {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao confirmar token, tente novamente", "DESCULPE")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Informe o token enviado para continuar", "ATENÇÃO")
        }
      },

      async consultaInscricao(id) {
        await axios.get(baseApiUrl + 'inscricoes/' + id)
        .then(response => {
          if (response.data) {
            this.inscricao.nome = response.data.nome
            this.inscricao.cpf = response.data.cpf
            this.inscricao.dataNascimento = response.data.dataNascimento
            this.inscricao.telefone = response.data.telefone
            this.inscricao.possuiNecessidade = response.data.possuiNecessidade
            this.inscricao.necessidadeEspecial = response.data.necessidadeEspecial
          }
        })
      },

      async consultaDivulgador(id) {
        await axios.get(baseApiUrl + 'Divulgadores/' + id)
        .then(response => {
          if (response.data) {
            if (response.data.ativo) {
              this.indicacao = true
              this.divulgador = response.data
              axios.patch(baseApiUrl + 'Divulgadores/' + id, { "qtdClicks": response.data.qtdClicks ? response.data.qtdClicks + 1 : 1 })
            }
          }
        })
      },

      retornaData(tipo) {
        return moment().format(tipo)
      },

      retornaPaginaPrincipal() {
        this.eventoSelecionado = []
        this.inscricao = this.inscricaoDefault

        if (this.PageIncricao) {
          this.PageIncricao = false
        } else {
          this.paginaInscricaoGrupo = false
        }
        
        this.pagePrincipal = true
      },

      async buscaUfs() {
        await axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
        .then(response => {
          if (response.data) {
            this.estados = response.data
          }
        })
      },

      async buscaMunicipios() {
        await axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/municipios?view=nivelado')
        .then(response => {
          if (response.data) {
            this.municipios = response.data
          }
        })
      },

      getItemText(item) {
        return item.nome
      },

      calculaValorTotal(setor, indice) {
        let vm = this

        // localiza o setor escolhido pelo preço e o salva na inscrição
        for (let i = 0; i < this.eventoSelecionado.setores.length; i++) {
          if (this.eventoSelecionado.setores[i].nome == setor) {
            if (this.verificaVagaDisponivel(this.eventoSelecionado.setores[i].nome) > 0) {
              this.inscricao[indice].valorPago = this.eventoSelecionado.setores[i].valor
              this.inscricao[indice].corSetor = this.eventoSelecionado.setores[i].cor
            } else {
              this.inscricao[indice].valorPago = ''
              this.inscricao[indice].setor = ''
              this.inscricao[indice].corSetor = ''
              vm.$refs.chamaSnackbar.snack("#F9A825", "Quantidade máxima atingida para o setor", "ATENÇÃO")
            }
            break
          }
        }

        if (this.inscricao[indice].tipoDocumento == 'CNPJ' && this.eventoSelecionado.desconto) {
          this.inscricao[indice].valorPago = parseFloat(this.inscricao[indice].valorPago.replace(',','.') - this.eventoSelecionado.desconto.replace(',','.')).toFixed(2).replace('.',',')
        }

        this.valorTotalCompra = 0

        this.inscricao.forEach(inscricao => {
          if (inscricao.valorPago) {
            this.valorTotalCompra += parseFloat(inscricao.valorPago.replace(',','.'))
          }
        });

        if (this.empresa.limiteInscricao == 'SETOR') {
          this.pegaVagasDisponiveis()
        }
      },

      async pegaVagasDisponiveis() {
        await axios.post(baseApiUrl + 'Empresas/vagasDisponiveis', {"empresaId": this.empresa.id})
        .then(response => {
          if (response.data) {
            this.vagasDisponiveis = response.data
          }

          if (this.inscricao.length > 0) {
            for (let i = 0; i < this.inscricao.length; i++) {
              if (this.inscricao[i].setor) {
                this.vagasDisponiveis[this.inscricao[i].setor] = this.vagasDisponiveis[this.inscricao[i].setor] - 1
              }
            }
          }
        })
      },

      verificaVagaDisponivel(setor) {
        return this.vagasDisponiveis[setor] - 1
      },

      limpaSetor(indice) {
        if (this.inscricao[indice].valorPago) {
          this.valorTotalCompra -= parseFloat(this.inscricao[indice].valorPago.replace(',','.'))
        }

        this.inscricao[indice].valorPago = ''
        this.inscricao[indice].setor = ''
        this.inscricao[indice].corSetor = ''
      },

      async retornoCEP() {
        this.isLoading = true
        if (/^[0-9]{5}-[0-9]{3}$/.test(this.inscricao.cep)) {
          await axios.get(`https://viacep.com.br/ws/${this.inscricao.cep.replace(/[^\d]+/g, '')}/json/`)
          .then(response => {
            if (response.data.erro == true || response.data.erro == 'true' || response.data.bairro == '' || response.data.localidade == '' || response.data.uf == '') {
              this.inscricao.logradouro = ''
              this.inscricao.estado = ''
              this.inscricao.cidade = ''
              this.inscricao.bairro = ''
            } else {
              this.inscricao.logradouro = response.data.logradouro.toUpperCase()
              this.inscricao.estado = response.data.uf.toUpperCase()
              this.inscricao.cidade = response.data.localidade.toUpperCase()
              this.inscricao.bairro = response.data.bairro.toUpperCase()
            }
          })
        }
        this.isLoading = false
      },

      inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          // Before adding a file
          // Filter system files or hide files
          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
            return prevent()
          }
          // Filter php html js file
          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
            return prevent()
          }
        }
      },

      inputFileFoto(newFile, oldFile) {
        if (newFile && !oldFile) {       
          var reader = new FileReader();        
          var file = this.arquivoFotoCache[0]
          
          //salva a base64 na variável
          reader.onloadend = function() { 
            document.getElementById("arquivoFoto").value = reader.result
          };            
          //Gera base64
          reader.readAsDataURL(file.file);  
          //this.files = []     
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileCertidaoNascimento(newFile, oldFile) {
        if (newFile && !oldFile) {       
          var reader = new FileReader();
          var file = this.arquivoCertidaoNascimentoCache[0]
          
          //salva a base64 na variável
          reader.onloadend = function() { 
            document.getElementById("arquivoCertidaoNascimento").value = reader.result   
          };            
          //Gera base64
          reader.readAsDataURL(newFile.file);  
          //this.files = []     
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileCnhRgPai(newFile, oldFile) {
        if (newFile && !oldFile) {       
          var reader = new FileReader();
          var file = this.arquivoCnhRg1Cache[0]
          
          //salva a base64 na variável
          reader.onloadend = function() { 
            document.getElementById("arquivoCnhRg1").value = reader.result   
          };            
          //Gera base64
          reader.readAsDataURL(newFile.file);  
          //this.files = []     
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileCnhRgMae(newFile, oldFile) {
        if (newFile && !oldFile) {       
          var reader = new FileReader();
          var file = this.arquivoCnhRg2Cache[0]
          
          //salva a base64 na variável
          reader.onloadend = function() { 
            document.getElementById("arquivoCnhRg2").value = reader.result   
          };            
          //Gera base64
          reader.readAsDataURL(newFile.file);  
          //this.files = []     
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileCnhRgRespFinanceiro(newFile, oldFile) {
        if (newFile && !oldFile) {       
          var reader = new FileReader();
          var file = this.arquivoCnhRg3Cache[0]
          
          //salva a base64 na variável
          reader.onloadend = function() { 
            document.getElementById("arquivoCnhRg3").value = reader.result   
          };            
          //Gera base64
          reader.readAsDataURL(newFile.file);  
          //this.files = []     
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileCadernetaVacinacao(newFile, oldFile) {
        if (newFile && !oldFile) {       
          var reader = new FileReader();      
          var file = this.arquivoCadernetaVacinacaoCache[0]
          
          //salva a base64 na variável
          reader.onloadend = function() { 
            document.getElementById("arquivoCadernetaVacinacao").value = reader.result   
          };            
          //Gera base64
          reader.readAsDataURL(newFile.file);  
          //this.files = []     
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileCartaoSus(newFile, oldFile) {
        if (newFile && !oldFile) {       
          var reader = new FileReader();  
          var file = this.arquivoCartaoSusCache[0]
          
          //salva a base64 na variável
          reader.onloadend = function() { 
            document.getElementById("arquivoCartaoSus").value = reader.result   
          };            
          //Gera base64
          reader.readAsDataURL(newFile.file);  
          //this.files = []     
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileComprovanteResidencia(newFile, oldFile) {
        if (newFile && !oldFile) {       
          var reader = new FileReader();
          var file = this.arquivoComprovanteResidenciaCache[0]
          
          //salva a base64 na variável
          reader.onloadend = function() { 
            document.getElementById("arquivoComprovanteResidencia").value = reader.result   
          };            
          //Gera base64
          reader.readAsDataURL(newFile.file);  
          //this.files = []     
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

    }
  }
</script>

<style scoped>
  /* LOGIN */

  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to right, #424242, #616161);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 0px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }

  .no-break {
    word-wrap: normal;   /* Usamos 'normal' em vez de 'break-word' para impedir a quebra no meio de palavras */
    word-break: keep-all; /* Isso também ajuda a prevenir a quebra no meio de palavras */
    white-space: pre-line; /* Isto vai respeitar os espaços em branco e quebras de linha */
  }

  a {
    text-decoration: none
  }
</style>
